import * as m from "react";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Script } from "@tecnobit-srl/script-manager";
import md5 from "md5";
import { each } from "lodash-es";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { LightGallery, LightGalleryItem } from "@tecnobit-srl/ui-lightgallery";
import { useMenuHeight } from "@tecnobit-srl/menu";
import { FontAwesome } from "@tecnobit-srl/ui-font-awesome";
import { useTranslation } from "react-i18next";
import { Badge } from "@tecnobit-srl/content-types-badge/lazy";
//#region \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod, mod.exports), cb = null), mod.exports);
var __exportAll = (all, no_symbols) => {
	let target = {};
	for (var name in all) __defProp(target, name, {
		get: all[name],
		enumerable: true
	});
	if (!no_symbols) __defProp(target, Symbol.toStringTag, { value: "Module" });
	return target;
};
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule || !__hasOwnProp.call(mod, "default") ? __defProp(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
//#endregion
//#region ../../../../../node_modules/domelementtype/lib/index.js
var require_lib$3 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Doctype = exports.CDATA = exports.Tag = exports.Style = exports.Script = exports.Comment = exports.Directive = exports.Text = exports.Root = exports.isTag = exports.ElementType = void 0;
	/** Types of elements found in htmlparser2's DOM */
	var ElementType;
	(function(ElementType) {
		/** Type for the root element of a document */
		ElementType["Root"] = "root";
		/** Type for Text */
		ElementType["Text"] = "text";
		/** Type for <? ... ?> */
		ElementType["Directive"] = "directive";
		/** Type for <!-- ... --> */
		ElementType["Comment"] = "comment";
		/** Type for <script> tags */
		ElementType["Script"] = "script";
		/** Type for <style> tags */
		ElementType["Style"] = "style";
		/** Type for Any tag */
		ElementType["Tag"] = "tag";
		/** Type for <![CDATA[ ... ]]> */
		ElementType["CDATA"] = "cdata";
		/** Type for <!doctype ...> */
		ElementType["Doctype"] = "doctype";
	})(ElementType = exports.ElementType || (exports.ElementType = {}));
	/**
	* Tests whether an element is a tag or not.
	*
	* @param elem Element to test
	*/
	function isTag(elem) {
		return elem.type === ElementType.Tag || elem.type === ElementType.Script || elem.type === ElementType.Style;
	}
	exports.isTag = isTag;
	/** Type for the root element of a document */
	exports.Root = ElementType.Root;
	/** Type for Text */
	exports.Text = ElementType.Text;
	/** Type for <? ... ?> */
	exports.Directive = ElementType.Directive;
	/** Type for <!-- ... --> */
	exports.Comment = ElementType.Comment;
	/** Type for <script> tags */
	exports.Script = ElementType.Script;
	/** Type for <style> tags */
	exports.Style = ElementType.Style;
	/** Type for Any tag */
	exports.Tag = ElementType.Tag;
	/** Type for <![CDATA[ ... ]]> */
	exports.CDATA = ElementType.CDATA;
	/** Type for <!doctype ...> */
	exports.Doctype = ElementType.Doctype;
}));
//#endregion
//#region ../../../../../node_modules/domhandler/lib/node.js
var require_node = /* @__PURE__ */ __commonJSMin(((exports, module, this$8) => {
	var __extends = this$8 && this$8.__extends || (function() {
		var extendStatics = function(d, b) {
			extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
				d.__proto__ = b;
			} || function(d, b) {
				for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
			};
			return extendStatics(d, b);
		};
		return function(d, b) {
			if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
			extendStatics(d, b);
			function __() {
				this.constructor = d;
			}
			d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
		};
	})();
	var __assign = this$8 && this$8.__assign || function() {
		__assign = Object.assign || function(t) {
			for (var s, i = 1, n = arguments.length; i < n; i++) {
				s = arguments[i];
				for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
			}
			return t;
		};
		return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.cloneNode = exports.hasChildren = exports.isDocument = exports.isDirective = exports.isComment = exports.isText = exports.isCDATA = exports.isTag = exports.Element = exports.Document = exports.CDATA = exports.NodeWithChildren = exports.ProcessingInstruction = exports.Comment = exports.Text = exports.DataNode = exports.Node = void 0;
	var domelementtype_1 = require_lib$3();
	/**
	* This object will be used as the prototype for Nodes when creating a
	* DOM-Level-1-compliant structure.
	*/
	var Node = function() {
		function Node() {
			/** Parent of the node */
			this.parent = null;
			/** Previous sibling */
			this.prev = null;
			/** Next sibling */
			this.next = null;
			/** The start index of the node. Requires `withStartIndices` on the handler to be `true. */
			this.startIndex = null;
			/** The end index of the node. Requires `withEndIndices` on the handler to be `true. */
			this.endIndex = null;
		}
		Object.defineProperty(Node.prototype, "parentNode", {
			/**
			* Same as {@link parent}.
			* [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
			*/
			get: function() {
				return this.parent;
			},
			set: function(parent) {
				this.parent = parent;
			},
			enumerable: false,
			configurable: true
		});
		Object.defineProperty(Node.prototype, "previousSibling", {
			/**
			* Same as {@link prev}.
			* [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
			*/
			get: function() {
				return this.prev;
			},
			set: function(prev) {
				this.prev = prev;
			},
			enumerable: false,
			configurable: true
		});
		Object.defineProperty(Node.prototype, "nextSibling", {
			/**
			* Same as {@link next}.
			* [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
			*/
			get: function() {
				return this.next;
			},
			set: function(next) {
				this.next = next;
			},
			enumerable: false,
			configurable: true
		});
		/**
		* Clone this node, and optionally its children.
		*
		* @param recursive Clone child nodes as well.
		* @returns A clone of the node.
		*/
		Node.prototype.cloneNode = function(recursive) {
			if (recursive === void 0) recursive = false;
			return cloneNode(this, recursive);
		};
		return Node;
	}();
	exports.Node = Node;
	/**
	* A node that contains some data.
	*/
	var DataNode = function(_super) {
		__extends(DataNode, _super);
		/**
		* @param data The content of the data node
		*/
		function DataNode(data) {
			var _this = _super.call(this) || this;
			_this.data = data;
			return _this;
		}
		Object.defineProperty(DataNode.prototype, "nodeValue", {
			/**
			* Same as {@link data}.
			* [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
			*/
			get: function() {
				return this.data;
			},
			set: function(data) {
				this.data = data;
			},
			enumerable: false,
			configurable: true
		});
		return DataNode;
	}(Node);
	exports.DataNode = DataNode;
	/**
	* Text within the document.
	*/
	var Text = function(_super) {
		__extends(Text, _super);
		function Text() {
			var _this = _super !== null && _super.apply(this, arguments) || this;
			_this.type = domelementtype_1.ElementType.Text;
			return _this;
		}
		Object.defineProperty(Text.prototype, "nodeType", {
			get: function() {
				return 3;
			},
			enumerable: false,
			configurable: true
		});
		return Text;
	}(DataNode);
	exports.Text = Text;
	/**
	* Comments within the document.
	*/
	var Comment = function(_super) {
		__extends(Comment, _super);
		function Comment() {
			var _this = _super !== null && _super.apply(this, arguments) || this;
			_this.type = domelementtype_1.ElementType.Comment;
			return _this;
		}
		Object.defineProperty(Comment.prototype, "nodeType", {
			get: function() {
				return 8;
			},
			enumerable: false,
			configurable: true
		});
		return Comment;
	}(DataNode);
	exports.Comment = Comment;
	/**
	* Processing instructions, including doc types.
	*/
	var ProcessingInstruction = function(_super) {
		__extends(ProcessingInstruction, _super);
		function ProcessingInstruction(name, data) {
			var _this = _super.call(this, data) || this;
			_this.name = name;
			_this.type = domelementtype_1.ElementType.Directive;
			return _this;
		}
		Object.defineProperty(ProcessingInstruction.prototype, "nodeType", {
			get: function() {
				return 1;
			},
			enumerable: false,
			configurable: true
		});
		return ProcessingInstruction;
	}(DataNode);
	exports.ProcessingInstruction = ProcessingInstruction;
	/**
	* A `Node` that can have children.
	*/
	var NodeWithChildren = function(_super) {
		__extends(NodeWithChildren, _super);
		/**
		* @param children Children of the node. Only certain node types can have children.
		*/
		function NodeWithChildren(children) {
			var _this = _super.call(this) || this;
			_this.children = children;
			return _this;
		}
		Object.defineProperty(NodeWithChildren.prototype, "firstChild", {
			/** First child of the node. */
			get: function() {
				var _a;
				return (_a = this.children[0]) !== null && _a !== void 0 ? _a : null;
			},
			enumerable: false,
			configurable: true
		});
		Object.defineProperty(NodeWithChildren.prototype, "lastChild", {
			/** Last child of the node. */
			get: function() {
				return this.children.length > 0 ? this.children[this.children.length - 1] : null;
			},
			enumerable: false,
			configurable: true
		});
		Object.defineProperty(NodeWithChildren.prototype, "childNodes", {
			/**
			* Same as {@link children}.
			* [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
			*/
			get: function() {
				return this.children;
			},
			set: function(children) {
				this.children = children;
			},
			enumerable: false,
			configurable: true
		});
		return NodeWithChildren;
	}(Node);
	exports.NodeWithChildren = NodeWithChildren;
	var CDATA = function(_super) {
		__extends(CDATA, _super);
		function CDATA() {
			var _this = _super !== null && _super.apply(this, arguments) || this;
			_this.type = domelementtype_1.ElementType.CDATA;
			return _this;
		}
		Object.defineProperty(CDATA.prototype, "nodeType", {
			get: function() {
				return 4;
			},
			enumerable: false,
			configurable: true
		});
		return CDATA;
	}(NodeWithChildren);
	exports.CDATA = CDATA;
	/**
	* The root node of the document.
	*/
	var Document = function(_super) {
		__extends(Document, _super);
		function Document() {
			var _this = _super !== null && _super.apply(this, arguments) || this;
			_this.type = domelementtype_1.ElementType.Root;
			return _this;
		}
		Object.defineProperty(Document.prototype, "nodeType", {
			get: function() {
				return 9;
			},
			enumerable: false,
			configurable: true
		});
		return Document;
	}(NodeWithChildren);
	exports.Document = Document;
	/**
	* An element within the DOM.
	*/
	var Element = function(_super) {
		__extends(Element, _super);
		/**
		* @param name Name of the tag, eg. `div`, `span`.
		* @param attribs Object mapping attribute names to attribute values.
		* @param children Children of the node.
		*/
		function Element(name, attribs, children, type) {
			if (children === void 0) children = [];
			if (type === void 0) type = name === "script" ? domelementtype_1.ElementType.Script : name === "style" ? domelementtype_1.ElementType.Style : domelementtype_1.ElementType.Tag;
			var _this = _super.call(this, children) || this;
			_this.name = name;
			_this.attribs = attribs;
			_this.type = type;
			return _this;
		}
		Object.defineProperty(Element.prototype, "nodeType", {
			get: function() {
				return 1;
			},
			enumerable: false,
			configurable: true
		});
		Object.defineProperty(Element.prototype, "tagName", {
			/**
			* Same as {@link name}.
			* [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
			*/
			get: function() {
				return this.name;
			},
			set: function(name) {
				this.name = name;
			},
			enumerable: false,
			configurable: true
		});
		Object.defineProperty(Element.prototype, "attributes", {
			get: function() {
				var _this = this;
				return Object.keys(this.attribs).map(function(name) {
					var _a, _b;
					return {
						name,
						value: _this.attribs[name],
						namespace: (_a = _this["x-attribsNamespace"]) === null || _a === void 0 ? void 0 : _a[name],
						prefix: (_b = _this["x-attribsPrefix"]) === null || _b === void 0 ? void 0 : _b[name]
					};
				});
			},
			enumerable: false,
			configurable: true
		});
		return Element;
	}(NodeWithChildren);
	exports.Element = Element;
	/**
	* @param node Node to check.
	* @returns `true` if the node is a `Element`, `false` otherwise.
	*/
	function isTag(node) {
		return (0, domelementtype_1.isTag)(node);
	}
	exports.isTag = isTag;
	/**
	* @param node Node to check.
	* @returns `true` if the node has the type `CDATA`, `false` otherwise.
	*/
	function isCDATA(node) {
		return node.type === domelementtype_1.ElementType.CDATA;
	}
	exports.isCDATA = isCDATA;
	/**
	* @param node Node to check.
	* @returns `true` if the node has the type `Text`, `false` otherwise.
	*/
	function isText(node) {
		return node.type === domelementtype_1.ElementType.Text;
	}
	exports.isText = isText;
	/**
	* @param node Node to check.
	* @returns `true` if the node has the type `Comment`, `false` otherwise.
	*/
	function isComment(node) {
		return node.type === domelementtype_1.ElementType.Comment;
	}
	exports.isComment = isComment;
	/**
	* @param node Node to check.
	* @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
	*/
	function isDirective(node) {
		return node.type === domelementtype_1.ElementType.Directive;
	}
	exports.isDirective = isDirective;
	/**
	* @param node Node to check.
	* @returns `true` if the node has the type `ProcessingInstruction`, `false` otherwise.
	*/
	function isDocument(node) {
		return node.type === domelementtype_1.ElementType.Root;
	}
	exports.isDocument = isDocument;
	/**
	* @param node Node to check.
	* @returns `true` if the node has children, `false` otherwise.
	*/
	function hasChildren(node) {
		return Object.prototype.hasOwnProperty.call(node, "children");
	}
	exports.hasChildren = hasChildren;
	/**
	* Clone a node, and optionally its children.
	*
	* @param recursive Clone child nodes as well.
	* @returns A clone of the node.
	*/
	function cloneNode(node, recursive) {
		if (recursive === void 0) recursive = false;
		var result;
		if (isText(node)) result = new Text(node.data);
		else if (isComment(node)) result = new Comment(node.data);
		else if (isTag(node)) {
			var children = recursive ? cloneChildren(node.children) : [];
			var clone_1 = new Element(node.name, __assign({}, node.attribs), children);
			children.forEach(function(child) {
				return child.parent = clone_1;
			});
			if (node.namespace != null) clone_1.namespace = node.namespace;
			if (node["x-attribsNamespace"]) clone_1["x-attribsNamespace"] = __assign({}, node["x-attribsNamespace"]);
			if (node["x-attribsPrefix"]) clone_1["x-attribsPrefix"] = __assign({}, node["x-attribsPrefix"]);
			result = clone_1;
		} else if (isCDATA(node)) {
			var children = recursive ? cloneChildren(node.children) : [];
			var clone_2 = new CDATA(children);
			children.forEach(function(child) {
				return child.parent = clone_2;
			});
			result = clone_2;
		} else if (isDocument(node)) {
			var children = recursive ? cloneChildren(node.children) : [];
			var clone_3 = new Document(children);
			children.forEach(function(child) {
				return child.parent = clone_3;
			});
			if (node["x-mode"]) clone_3["x-mode"] = node["x-mode"];
			result = clone_3;
		} else if (isDirective(node)) {
			var instruction = new ProcessingInstruction(node.name, node.data);
			if (node["x-name"] != null) {
				instruction["x-name"] = node["x-name"];
				instruction["x-publicId"] = node["x-publicId"];
				instruction["x-systemId"] = node["x-systemId"];
			}
			result = instruction;
		} else throw new Error("Not implemented yet: ".concat(node.type));
		result.startIndex = node.startIndex;
		result.endIndex = node.endIndex;
		if (node.sourceCodeLocation != null) result.sourceCodeLocation = node.sourceCodeLocation;
		return result;
	}
	exports.cloneNode = cloneNode;
	function cloneChildren(childs) {
		var children = childs.map(function(child) {
			return cloneNode(child, true);
		});
		for (var i = 1; i < children.length; i++) {
			children[i].prev = children[i - 1];
			children[i - 1].next = children[i];
		}
		return children;
	}
}));
//#endregion
//#region ../../../../../node_modules/domhandler/lib/index.js
var require_lib$2 = /* @__PURE__ */ __commonJSMin(((exports, module, this$7) => {
	var __createBinding = this$7 && this$7.__createBinding || (Object.create ? (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		var desc = Object.getOwnPropertyDescriptor(m, k);
		if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
			enumerable: true,
			get: function() {
				return m[k];
			}
		};
		Object.defineProperty(o, k2, desc);
	}) : (function(o, m, k, k2) {
		if (k2 === void 0) k2 = k;
		o[k2] = m[k];
	}));
	var __exportStar = this$7 && this$7.__exportStar || function(m, exports) {
		for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DomHandler = void 0;
	var domelementtype_1 = require_lib$3();
	var node_js_1 = require_node();
	__exportStar(require_node(), exports);
	var defaultOpts = {
		withStartIndices: false,
		withEndIndices: false,
		xmlMode: false
	};
	var DomHandler = function() {
		/**
		* @param callback Called once parsing has completed.
		* @param options Settings for the handler.
		* @param elementCB Callback whenever a tag is closed.
		*/
		function DomHandler(callback, options, elementCB) {
			/** The elements of the DOM */
			this.dom = [];
			/** The root element for the DOM */
			this.root = new node_js_1.Document(this.dom);
			/** Indicated whether parsing has been completed. */
			this.done = false;
			/** Stack of open tags. */
			this.tagStack = [this.root];
			/** A data node that is still being written to. */
			this.lastNode = null;
			/** Reference to the parser instance. Used for location information. */
			this.parser = null;
			if (typeof options === "function") {
				elementCB = options;
				options = defaultOpts;
			}
			if (typeof callback === "object") {
				options = callback;
				callback = void 0;
			}
			this.callback = callback !== null && callback !== void 0 ? callback : null;
			this.options = options !== null && options !== void 0 ? options : defaultOpts;
			this.elementCB = elementCB !== null && elementCB !== void 0 ? elementCB : null;
		}
		DomHandler.prototype.onparserinit = function(parser) {
			this.parser = parser;
		};
		DomHandler.prototype.onreset = function() {
			this.dom = [];
			this.root = new node_js_1.Document(this.dom);
			this.done = false;
			this.tagStack = [this.root];
			this.lastNode = null;
			this.parser = null;
		};
		DomHandler.prototype.onend = function() {
			if (this.done) return;
			this.done = true;
			this.parser = null;
			this.handleCallback(null);
		};
		DomHandler.prototype.onerror = function(error) {
			this.handleCallback(error);
		};
		DomHandler.prototype.onclosetag = function() {
			this.lastNode = null;
			var elem = this.tagStack.pop();
			if (this.options.withEndIndices) elem.endIndex = this.parser.endIndex;
			if (this.elementCB) this.elementCB(elem);
		};
		DomHandler.prototype.onopentag = function(name, attribs) {
			var type = this.options.xmlMode ? domelementtype_1.ElementType.Tag : void 0;
			var element = new node_js_1.Element(name, attribs, void 0, type);
			this.addNode(element);
			this.tagStack.push(element);
		};
		DomHandler.prototype.ontext = function(data) {
			var lastNode = this.lastNode;
			if (lastNode && lastNode.type === domelementtype_1.ElementType.Text) {
				lastNode.data += data;
				if (this.options.withEndIndices) lastNode.endIndex = this.parser.endIndex;
			} else {
				var node = new node_js_1.Text(data);
				this.addNode(node);
				this.lastNode = node;
			}
		};
		DomHandler.prototype.oncomment = function(data) {
			if (this.lastNode && this.lastNode.type === domelementtype_1.ElementType.Comment) {
				this.lastNode.data += data;
				return;
			}
			var node = new node_js_1.Comment(data);
			this.addNode(node);
			this.lastNode = node;
		};
		DomHandler.prototype.oncommentend = function() {
			this.lastNode = null;
		};
		DomHandler.prototype.oncdatastart = function() {
			var text = new node_js_1.Text("");
			var node = new node_js_1.CDATA([text]);
			this.addNode(node);
			text.parent = node;
			this.lastNode = text;
		};
		DomHandler.prototype.oncdataend = function() {
			this.lastNode = null;
		};
		DomHandler.prototype.onprocessinginstruction = function(name, data) {
			var node = new node_js_1.ProcessingInstruction(name, data);
			this.addNode(node);
		};
		DomHandler.prototype.handleCallback = function(error) {
			if (typeof this.callback === "function") this.callback(error, this.dom);
			else if (error) throw error;
		};
		DomHandler.prototype.addNode = function(node) {
			var parent = this.tagStack[this.tagStack.length - 1];
			var previousSibling = parent.children[parent.children.length - 1];
			if (this.options.withStartIndices) node.startIndex = this.parser.startIndex;
			if (this.options.withEndIndices) node.endIndex = this.parser.endIndex;
			parent.children.push(node);
			if (previousSibling) {
				node.prev = previousSibling;
				previousSibling.next = node;
			}
			node.parent = parent;
			this.lastNode = null;
		};
		return DomHandler;
	}();
	exports.DomHandler = DomHandler;
	exports.default = DomHandler;
}));
//#endregion
//#region ../../../../../node_modules/html-dom-parser/lib/client/constants.js
var require_constants = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = exports.CARRIAGE_RETURN_PLACEHOLDER = exports.CARRIAGE_RETURN_REGEX = exports.CARRIAGE_RETURN = exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES = void 0;
	/**
	* SVG elements are case-sensitive.
	*
	* @see https://developer.mozilla.org/docs/Web/SVG/Element#svg_elements_a_to_z
	*/
	exports.CASE_SENSITIVE_TAG_NAMES = [
		"animateMotion",
		"animateTransform",
		"clipPath",
		"feBlend",
		"feColorMatrix",
		"feComponentTransfer",
		"feComposite",
		"feConvolveMatrix",
		"feDiffuseLighting",
		"feDisplacementMap",
		"feDropShadow",
		"feFlood",
		"feFuncA",
		"feFuncB",
		"feFuncG",
		"feFuncR",
		"feGaussianBlur",
		"feImage",
		"feMerge",
		"feMergeNode",
		"feMorphology",
		"feOffset",
		"fePointLight",
		"feSpecularLighting",
		"feSpotLight",
		"feTile",
		"feTurbulence",
		"foreignObject",
		"linearGradient",
		"radialGradient",
		"textPath"
	];
	exports.CASE_SENSITIVE_TAG_NAMES_MAP = exports.CASE_SENSITIVE_TAG_NAMES.reduce(function(accumulator, tagName) {
		accumulator[tagName.toLowerCase()] = tagName;
		return accumulator;
	}, {});
	exports.CARRIAGE_RETURN = "\r";
	exports.CARRIAGE_RETURN_REGEX = new RegExp(exports.CARRIAGE_RETURN, "g");
	exports.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__");
	exports.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(exports.CARRIAGE_RETURN_PLACEHOLDER, "g");
}));
//#endregion
//#region ../../../../../node_modules/html-dom-parser/lib/client/utilities.js
var require_utilities$2 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.formatAttributes = formatAttributes;
	exports.escapeSpecialCharacters = escapeSpecialCharacters;
	exports.revertEscapedCharacters = revertEscapedCharacters;
	exports.formatDOM = formatDOM;
	var domhandler_1 = require_lib$2();
	var constants_1 = require_constants();
	/**
	* Gets case-sensitive tag name.
	*
	* @param tagName - Tag name in lowercase.
	* @returns - Case-sensitive tag name.
	*/
	function getCaseSensitiveTagName(tagName) {
		return constants_1.CASE_SENSITIVE_TAG_NAMES_MAP[tagName];
	}
	/**
	* Formats DOM attributes to a hash map.
	*
	* @param attributes - List of attributes.
	* @returns - Map of attribute name to value.
	*/
	function formatAttributes(attributes) {
		var map = {};
		var index = 0;
		var attributesLength = attributes.length;
		for (; index < attributesLength; index++) {
			var attribute = attributes[index];
			map[attribute.name] = attribute.value;
		}
		return map;
	}
	/**
	* Corrects the tag name if it is case-sensitive (SVG).
	* Otherwise, returns the lowercase tag name (HTML).
	*
	* @param tagName - Lowercase tag name.
	* @returns - Formatted tag name.
	*/
	function formatTagName(tagName) {
		tagName = tagName.toLowerCase();
		var caseSensitiveTagName = getCaseSensitiveTagName(tagName);
		if (caseSensitiveTagName) return caseSensitiveTagName;
		return tagName;
	}
	/**
	* Escapes special characters before parsing.
	*
	* @param html - The HTML string.
	* @returns - HTML string with escaped special characters.
	*/
	function escapeSpecialCharacters(html) {
		return html.replace(constants_1.CARRIAGE_RETURN_REGEX, constants_1.CARRIAGE_RETURN_PLACEHOLDER);
	}
	/**
	* Reverts escaped special characters back to actual characters.
	*
	* @param text - The text with escaped characters.
	* @returns - Text with escaped characters reverted.
	*/
	function revertEscapedCharacters(text) {
		return text.replace(constants_1.CARRIAGE_RETURN_PLACEHOLDER_REGEX, constants_1.CARRIAGE_RETURN);
	}
	/**
	* Transforms DOM nodes to `domhandler` nodes.
	*
	* @param nodes - DOM nodes.
	* @param parent - Parent node.
	* @param directive - Directive.
	* @returns - Nodes.
	*/
	function formatDOM(nodes, parent, directive) {
		if (parent === void 0) parent = null;
		var domNodes = [];
		var current;
		var index = 0;
		var nodesLength = nodes.length;
		for (; index < nodesLength; index++) {
			var node = nodes[index];
			switch (node.nodeType) {
				case 1:
					var tagName = formatTagName(node.nodeName);
					current = new domhandler_1.Element(tagName, formatAttributes(node.attributes));
					current.children = formatDOM(tagName === "template" ? node.content.childNodes : node.childNodes, current);
					break;
				case 3:
					current = new domhandler_1.Text(revertEscapedCharacters(node.nodeValue));
					break;
				case 8:
					current = new domhandler_1.Comment(node.nodeValue);
					break;
				default: continue;
			}
			var prev = domNodes[index - 1] || null;
			if (prev) prev.next = current;
			current.parent = parent;
			current.prev = prev;
			current.next = null;
			domNodes.push(current);
		}
		if (directive) {
			current = new domhandler_1.ProcessingInstruction(directive.substring(0, directive.indexOf(" ")).toLowerCase(), directive);
			current.next = domNodes[0] || null;
			current.parent = parent;
			domNodes.unshift(current);
			if (domNodes[1]) domNodes[1].prev = domNodes[0];
		}
		return domNodes;
	}
}));
//#endregion
//#region ../../../../../node_modules/html-dom-parser/lib/client/domparser.js
var require_domparser = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = domparser;
	var utilities_1 = require_utilities$2();
	var HTML = "html";
	var HEAD = "head";
	var BODY = "body";
	var FIRST_TAG_REGEX = /<([a-zA-Z]+[0-9]?)/;
	var HEAD_TAG_REGEX = /<head[^]*>/i;
	var BODY_TAG_REGEX = /<body[^]*>/i;
	var parseFromDocument = function(html, tagName) {
		/* istanbul ignore next */
		throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
	};
	var parseFromString = function(html, tagName) {
		/* istanbul ignore next */
		throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
	};
	var DOMParser = typeof window === "object" && window.DOMParser;
	/**
	* DOMParser (performance: slow).
	*
	* @see https://developer.mozilla.org/docs/Web/API/DOMParser#Parsing_an_SVG_or_HTML_document
	*/
	if (typeof DOMParser === "function") {
		var domParser_1 = new DOMParser();
		var mimeType_1 = "text/html";
		/**
		* Creates an HTML document using `DOMParser.parseFromString`.
		*
		* @param html - The HTML string.
		* @param tagName - The element to render the HTML (with 'body' as fallback).
		* @returns - Document.
		*/
		parseFromString = function(html, tagName) {
			if (tagName)
 /* istanbul ignore next */
			html = "<".concat(tagName, ">").concat(html, "</").concat(tagName, ">");
			return domParser_1.parseFromString(html, mimeType_1);
		};
		parseFromDocument = parseFromString;
	}
	/**
	* DOMImplementation (performance: fair).
	*
	* @see https://developer.mozilla.org/docs/Web/API/DOMImplementation/createHTMLDocument
	*/
	if (typeof document === "object" && document.implementation) {
		var htmlDocument_1 = document.implementation.createHTMLDocument();
		/**
		* Use HTML document created by `document.implementation.createHTMLDocument`.
		*
		* @param html - The HTML string.
		* @param tagName - The element to render the HTML (with 'body' as fallback).
		* @returns - Document
		*/
		parseFromDocument = function(html, tagName) {
			if (tagName) {
				var element = htmlDocument_1.documentElement.querySelector(tagName);
				if (element) element.innerHTML = html;
				return htmlDocument_1;
			}
			htmlDocument_1.documentElement.innerHTML = html;
			return htmlDocument_1;
		};
	}
	/**
	* Template (performance: fast).
	*
	* @see https://developer.mozilla.org/docs/Web/HTML/Element/template
	*/
	var template = typeof document === "object" && document.createElement("template");
	var parseFromTemplate;
	if (template && template.content)
 /**
	* Uses a template element (content fragment) to parse HTML.
	*
	* @param html - HTML string.
	* @returns - Nodes.
	*/
	parseFromTemplate = function(html) {
		template.innerHTML = html;
		return template.content.childNodes;
	};
	/**
	* Parses HTML string to DOM nodes.
	*
	* @param html - HTML markup.
	* @returns - DOM nodes.
	*/
	function domparser(html) {
		var _a, _b;
		html = (0, utilities_1.escapeSpecialCharacters)(html);
		var match = html.match(FIRST_TAG_REGEX);
		var firstTagName = match && match[1] ? match[1].toLowerCase() : "";
		switch (firstTagName) {
			case HTML:
				var doc = parseFromString(html);
				if (!HEAD_TAG_REGEX.test(html)) {
					var element = doc.querySelector(HEAD);
					(_a = element === null || element === void 0 ? void 0 : element.parentNode) === null || _a === void 0 || _a.removeChild(element);
				}
				if (!BODY_TAG_REGEX.test(html)) {
					var element = doc.querySelector(BODY);
					(_b = element === null || element === void 0 ? void 0 : element.parentNode) === null || _b === void 0 || _b.removeChild(element);
				}
				return doc.querySelectorAll(HTML);
			case HEAD:
			case BODY:
				var elements = parseFromDocument(html).querySelectorAll(firstTagName);
				if (BODY_TAG_REGEX.test(html) && HEAD_TAG_REGEX.test(html)) return elements[0].parentNode.childNodes;
				return elements;
			default:
				if (parseFromTemplate) return parseFromTemplate(html);
				var element = parseFromDocument(html, BODY).querySelector(BODY);
				return element.childNodes;
		}
	}
}));
//#endregion
//#region ../../../../../node_modules/html-dom-parser/lib/client/html-to-dom.js
var require_html_to_dom = /* @__PURE__ */ __commonJSMin(((exports, module, this$6) => {
	var __importDefault = this$6 && this$6.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = HTMLDOMParser;
	var domparser_1 = __importDefault(require_domparser());
	var utilities_1 = require_utilities$2();
	var DIRECTIVE_REGEX = /<(![a-zA-Z\s]+)>/;
	/**
	* Parses HTML string to DOM nodes in browser.
	*
	* @param html - HTML markup.
	* @returns - DOM elements.
	*/
	function HTMLDOMParser(html) {
		if (typeof html !== "string") throw new TypeError("First argument must be a string");
		if (!html) return [];
		var match = html.match(DIRECTIVE_REGEX);
		var directive = match ? match[1] : void 0;
		return (0, utilities_1.formatDOM)((0, domparser_1.default)(html), null, directive);
	}
}));
//#endregion
//#region ../../../../../node_modules/react-property/lib/possibleStandardNamesOptimized.js
var require_possibleStandardNamesOptimized = /* @__PURE__ */ __commonJSMin(((exports) => {
	exports.SAME = 0;
	exports.CAMELCASE = 1;
	exports.possibleStandardNames = {
		accept: 0,
		acceptCharset: 1,
		"accept-charset": "acceptCharset",
		accessKey: 1,
		action: 0,
		allowFullScreen: 1,
		alt: 0,
		as: 0,
		async: 0,
		autoCapitalize: 1,
		autoComplete: 1,
		autoCorrect: 1,
		autoFocus: 1,
		autoPlay: 1,
		autoSave: 1,
		capture: 0,
		cellPadding: 1,
		cellSpacing: 1,
		challenge: 0,
		charSet: 1,
		checked: 0,
		children: 0,
		cite: 0,
		class: "className",
		classID: 1,
		className: 1,
		cols: 0,
		colSpan: 1,
		content: 0,
		contentEditable: 1,
		contextMenu: 1,
		controls: 0,
		controlsList: 1,
		coords: 0,
		crossOrigin: 1,
		dangerouslySetInnerHTML: 1,
		data: 0,
		dateTime: 1,
		default: 0,
		defaultChecked: 1,
		defaultValue: 1,
		defer: 0,
		dir: 0,
		disabled: 0,
		disablePictureInPicture: 1,
		disableRemotePlayback: 1,
		download: 0,
		draggable: 0,
		encType: 1,
		enterKeyHint: 1,
		for: "htmlFor",
		form: 0,
		formMethod: 1,
		formAction: 1,
		formEncType: 1,
		formNoValidate: 1,
		formTarget: 1,
		frameBorder: 1,
		headers: 0,
		height: 0,
		hidden: 0,
		high: 0,
		href: 0,
		hrefLang: 1,
		htmlFor: 1,
		httpEquiv: 1,
		"http-equiv": "httpEquiv",
		icon: 0,
		id: 0,
		innerHTML: 1,
		inputMode: 1,
		integrity: 0,
		is: 0,
		itemID: 1,
		itemProp: 1,
		itemRef: 1,
		itemScope: 1,
		itemType: 1,
		keyParams: 1,
		keyType: 1,
		kind: 0,
		label: 0,
		lang: 0,
		list: 0,
		loop: 0,
		low: 0,
		manifest: 0,
		marginWidth: 1,
		marginHeight: 1,
		max: 0,
		maxLength: 1,
		media: 0,
		mediaGroup: 1,
		method: 0,
		min: 0,
		minLength: 1,
		multiple: 0,
		muted: 0,
		name: 0,
		noModule: 1,
		nonce: 0,
		noValidate: 1,
		open: 0,
		optimum: 0,
		pattern: 0,
		placeholder: 0,
		playsInline: 1,
		poster: 0,
		preload: 0,
		profile: 0,
		radioGroup: 1,
		readOnly: 1,
		referrerPolicy: 1,
		rel: 0,
		required: 0,
		reversed: 0,
		role: 0,
		rows: 0,
		rowSpan: 1,
		sandbox: 0,
		scope: 0,
		scoped: 0,
		scrolling: 0,
		seamless: 0,
		selected: 0,
		shape: 0,
		size: 0,
		sizes: 0,
		span: 0,
		spellCheck: 1,
		src: 0,
		srcDoc: 1,
		srcLang: 1,
		srcSet: 1,
		start: 0,
		step: 0,
		style: 0,
		summary: 0,
		tabIndex: 1,
		target: 0,
		title: 0,
		type: 0,
		useMap: 1,
		value: 0,
		width: 0,
		wmode: 0,
		wrap: 0,
		about: 0,
		accentHeight: 1,
		"accent-height": "accentHeight",
		accumulate: 0,
		additive: 0,
		alignmentBaseline: 1,
		"alignment-baseline": "alignmentBaseline",
		allowReorder: 1,
		alphabetic: 0,
		amplitude: 0,
		arabicForm: 1,
		"arabic-form": "arabicForm",
		ascent: 0,
		attributeName: 1,
		attributeType: 1,
		autoReverse: 1,
		azimuth: 0,
		baseFrequency: 1,
		baselineShift: 1,
		"baseline-shift": "baselineShift",
		baseProfile: 1,
		bbox: 0,
		begin: 0,
		bias: 0,
		by: 0,
		calcMode: 1,
		capHeight: 1,
		"cap-height": "capHeight",
		clip: 0,
		clipPath: 1,
		"clip-path": "clipPath",
		clipPathUnits: 1,
		clipRule: 1,
		"clip-rule": "clipRule",
		color: 0,
		colorInterpolation: 1,
		"color-interpolation": "colorInterpolation",
		colorInterpolationFilters: 1,
		"color-interpolation-filters": "colorInterpolationFilters",
		colorProfile: 1,
		"color-profile": "colorProfile",
		colorRendering: 1,
		"color-rendering": "colorRendering",
		contentScriptType: 1,
		contentStyleType: 1,
		cursor: 0,
		cx: 0,
		cy: 0,
		d: 0,
		datatype: 0,
		decelerate: 0,
		descent: 0,
		diffuseConstant: 1,
		direction: 0,
		display: 0,
		divisor: 0,
		dominantBaseline: 1,
		"dominant-baseline": "dominantBaseline",
		dur: 0,
		dx: 0,
		dy: 0,
		edgeMode: 1,
		elevation: 0,
		enableBackground: 1,
		"enable-background": "enableBackground",
		end: 0,
		exponent: 0,
		externalResourcesRequired: 1,
		fill: 0,
		fillOpacity: 1,
		"fill-opacity": "fillOpacity",
		fillRule: 1,
		"fill-rule": "fillRule",
		filter: 0,
		filterRes: 1,
		filterUnits: 1,
		floodOpacity: 1,
		"flood-opacity": "floodOpacity",
		floodColor: 1,
		"flood-color": "floodColor",
		focusable: 0,
		fontFamily: 1,
		"font-family": "fontFamily",
		fontSize: 1,
		"font-size": "fontSize",
		fontSizeAdjust: 1,
		"font-size-adjust": "fontSizeAdjust",
		fontStretch: 1,
		"font-stretch": "fontStretch",
		fontStyle: 1,
		"font-style": "fontStyle",
		fontVariant: 1,
		"font-variant": "fontVariant",
		fontWeight: 1,
		"font-weight": "fontWeight",
		format: 0,
		from: 0,
		fx: 0,
		fy: 0,
		g1: 0,
		g2: 0,
		glyphName: 1,
		"glyph-name": "glyphName",
		glyphOrientationHorizontal: 1,
		"glyph-orientation-horizontal": "glyphOrientationHorizontal",
		glyphOrientationVertical: 1,
		"glyph-orientation-vertical": "glyphOrientationVertical",
		glyphRef: 1,
		gradientTransform: 1,
		gradientUnits: 1,
		hanging: 0,
		horizAdvX: 1,
		"horiz-adv-x": "horizAdvX",
		horizOriginX: 1,
		"horiz-origin-x": "horizOriginX",
		ideographic: 0,
		imageRendering: 1,
		"image-rendering": "imageRendering",
		in2: 0,
		in: 0,
		inlist: 0,
		intercept: 0,
		k1: 0,
		k2: 0,
		k3: 0,
		k4: 0,
		k: 0,
		kernelMatrix: 1,
		kernelUnitLength: 1,
		kerning: 0,
		keyPoints: 1,
		keySplines: 1,
		keyTimes: 1,
		lengthAdjust: 1,
		letterSpacing: 1,
		"letter-spacing": "letterSpacing",
		lightingColor: 1,
		"lighting-color": "lightingColor",
		limitingConeAngle: 1,
		local: 0,
		markerEnd: 1,
		"marker-end": "markerEnd",
		markerHeight: 1,
		markerMid: 1,
		"marker-mid": "markerMid",
		markerStart: 1,
		"marker-start": "markerStart",
		markerUnits: 1,
		markerWidth: 1,
		mask: 0,
		maskContentUnits: 1,
		maskUnits: 1,
		mathematical: 0,
		mode: 0,
		numOctaves: 1,
		offset: 0,
		opacity: 0,
		operator: 0,
		order: 0,
		orient: 0,
		orientation: 0,
		origin: 0,
		overflow: 0,
		overlinePosition: 1,
		"overline-position": "overlinePosition",
		overlineThickness: 1,
		"overline-thickness": "overlineThickness",
		paintOrder: 1,
		"paint-order": "paintOrder",
		panose1: 0,
		"panose-1": "panose1",
		pathLength: 1,
		patternContentUnits: 1,
		patternTransform: 1,
		patternUnits: 1,
		pointerEvents: 1,
		"pointer-events": "pointerEvents",
		points: 0,
		pointsAtX: 1,
		pointsAtY: 1,
		pointsAtZ: 1,
		prefix: 0,
		preserveAlpha: 1,
		preserveAspectRatio: 1,
		primitiveUnits: 1,
		property: 0,
		r: 0,
		radius: 0,
		refX: 1,
		refY: 1,
		renderingIntent: 1,
		"rendering-intent": "renderingIntent",
		repeatCount: 1,
		repeatDur: 1,
		requiredExtensions: 1,
		requiredFeatures: 1,
		resource: 0,
		restart: 0,
		result: 0,
		results: 0,
		rotate: 0,
		rx: 0,
		ry: 0,
		scale: 0,
		security: 0,
		seed: 0,
		shapeRendering: 1,
		"shape-rendering": "shapeRendering",
		slope: 0,
		spacing: 0,
		specularConstant: 1,
		specularExponent: 1,
		speed: 0,
		spreadMethod: 1,
		startOffset: 1,
		stdDeviation: 1,
		stemh: 0,
		stemv: 0,
		stitchTiles: 1,
		stopColor: 1,
		"stop-color": "stopColor",
		stopOpacity: 1,
		"stop-opacity": "stopOpacity",
		strikethroughPosition: 1,
		"strikethrough-position": "strikethroughPosition",
		strikethroughThickness: 1,
		"strikethrough-thickness": "strikethroughThickness",
		string: 0,
		stroke: 0,
		strokeDasharray: 1,
		"stroke-dasharray": "strokeDasharray",
		strokeDashoffset: 1,
		"stroke-dashoffset": "strokeDashoffset",
		strokeLinecap: 1,
		"stroke-linecap": "strokeLinecap",
		strokeLinejoin: 1,
		"stroke-linejoin": "strokeLinejoin",
		strokeMiterlimit: 1,
		"stroke-miterlimit": "strokeMiterlimit",
		strokeWidth: 1,
		"stroke-width": "strokeWidth",
		strokeOpacity: 1,
		"stroke-opacity": "strokeOpacity",
		suppressContentEditableWarning: 1,
		suppressHydrationWarning: 1,
		surfaceScale: 1,
		systemLanguage: 1,
		tableValues: 1,
		targetX: 1,
		targetY: 1,
		textAnchor: 1,
		"text-anchor": "textAnchor",
		textDecoration: 1,
		"text-decoration": "textDecoration",
		textLength: 1,
		textRendering: 1,
		"text-rendering": "textRendering",
		to: 0,
		transform: 0,
		typeof: 0,
		u1: 0,
		u2: 0,
		underlinePosition: 1,
		"underline-position": "underlinePosition",
		underlineThickness: 1,
		"underline-thickness": "underlineThickness",
		unicode: 0,
		unicodeBidi: 1,
		"unicode-bidi": "unicodeBidi",
		unicodeRange: 1,
		"unicode-range": "unicodeRange",
		unitsPerEm: 1,
		"units-per-em": "unitsPerEm",
		unselectable: 0,
		vAlphabetic: 1,
		"v-alphabetic": "vAlphabetic",
		values: 0,
		vectorEffect: 1,
		"vector-effect": "vectorEffect",
		version: 0,
		vertAdvY: 1,
		"vert-adv-y": "vertAdvY",
		vertOriginX: 1,
		"vert-origin-x": "vertOriginX",
		vertOriginY: 1,
		"vert-origin-y": "vertOriginY",
		vHanging: 1,
		"v-hanging": "vHanging",
		vIdeographic: 1,
		"v-ideographic": "vIdeographic",
		viewBox: 1,
		viewTarget: 1,
		visibility: 0,
		vMathematical: 1,
		"v-mathematical": "vMathematical",
		vocab: 0,
		widths: 0,
		wordSpacing: 1,
		"word-spacing": "wordSpacing",
		writingMode: 1,
		"writing-mode": "writingMode",
		x1: 0,
		x2: 0,
		x: 0,
		xChannelSelector: 1,
		xHeight: 1,
		"x-height": "xHeight",
		xlinkActuate: 1,
		"xlink:actuate": "xlinkActuate",
		xlinkArcrole: 1,
		"xlink:arcrole": "xlinkArcrole",
		xlinkHref: 1,
		"xlink:href": "xlinkHref",
		xlinkRole: 1,
		"xlink:role": "xlinkRole",
		xlinkShow: 1,
		"xlink:show": "xlinkShow",
		xlinkTitle: 1,
		"xlink:title": "xlinkTitle",
		xlinkType: 1,
		"xlink:type": "xlinkType",
		xmlBase: 1,
		"xml:base": "xmlBase",
		xmlLang: 1,
		"xml:lang": "xmlLang",
		xmlns: 0,
		"xml:space": "xmlSpace",
		xmlnsXlink: 1,
		"xmlns:xlink": "xmlnsXlink",
		xmlSpace: 1,
		y1: 0,
		y2: 0,
		y: 0,
		yChannelSelector: 1,
		z: 0,
		zoomAndPan: 1
	};
}));
//#endregion
//#region ../../../../../node_modules/react-property/lib/index.js
var require_lib$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	/**
	* Copyright (c) Facebook, Inc. and its affiliates.
	*
	* This source code is licensed under the MIT license found in the
	* LICENSE file in the root directory of this source tree.
	*
	* 
	*/
	var RESERVED = 0;
	var STRING = 1;
	var BOOLEANISH_STRING = 2;
	var BOOLEAN = 3;
	var OVERLOADED_BOOLEAN = 4;
	var NUMERIC = 5;
	var POSITIVE_NUMERIC = 6;
	function getPropertyInfo(name) {
		return properties.hasOwnProperty(name) ? properties[name] : null;
	}
	function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
		this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
		this.attributeName = attributeName;
		this.attributeNamespace = attributeNamespace;
		this.mustUseProperty = mustUseProperty;
		this.propertyName = name;
		this.type = type;
		this.sanitizeURL = sanitizeURL;
		this.removeEmptyString = removeEmptyString;
	}
	var properties = {};
	[
		"children",
		"dangerouslySetInnerHTML",
		"defaultValue",
		"defaultChecked",
		"innerHTML",
		"suppressContentEditableWarning",
		"suppressHydrationWarning",
		"style"
	].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
	});
	[
		["acceptCharset", "accept-charset"],
		["className", "class"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"]
	].forEach(([name, attributeName]) => {
		properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
	});
	[
		"contentEditable",
		"draggable",
		"spellCheck",
		"value"
	].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
	});
	[
		"autoReverse",
		"externalResourcesRequired",
		"focusable",
		"preserveAlpha"
	].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
	});
	[
		"allowFullScreen",
		"async",
		"autoFocus",
		"autoPlay",
		"controls",
		"default",
		"defer",
		"disabled",
		"disablePictureInPicture",
		"disableRemotePlayback",
		"formNoValidate",
		"hidden",
		"loop",
		"noModule",
		"noValidate",
		"open",
		"playsInline",
		"readOnly",
		"required",
		"reversed",
		"scoped",
		"seamless",
		"itemScope"
	].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
	});
	[
		"checked",
		"multiple",
		"muted",
		"selected"
	].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
	});
	["capture", "download"].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
	});
	[
		"cols",
		"rows",
		"size",
		"span"
	].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
	});
	["rowSpan", "start"].forEach((name) => {
		properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
	});
	var CAMELIZE = /[\-\:]([a-z])/g;
	var capitalize = (token) => token[1].toUpperCase();
	[
		"accent-height",
		"alignment-baseline",
		"arabic-form",
		"baseline-shift",
		"cap-height",
		"clip-path",
		"clip-rule",
		"color-interpolation",
		"color-interpolation-filters",
		"color-profile",
		"color-rendering",
		"dominant-baseline",
		"enable-background",
		"fill-opacity",
		"fill-rule",
		"flood-color",
		"flood-opacity",
		"font-family",
		"font-size",
		"font-size-adjust",
		"font-stretch",
		"font-style",
		"font-variant",
		"font-weight",
		"glyph-name",
		"glyph-orientation-horizontal",
		"glyph-orientation-vertical",
		"horiz-adv-x",
		"horiz-origin-x",
		"image-rendering",
		"letter-spacing",
		"lighting-color",
		"marker-end",
		"marker-mid",
		"marker-start",
		"overline-position",
		"overline-thickness",
		"paint-order",
		"panose-1",
		"pointer-events",
		"rendering-intent",
		"shape-rendering",
		"stop-color",
		"stop-opacity",
		"strikethrough-position",
		"strikethrough-thickness",
		"stroke-dasharray",
		"stroke-dashoffset",
		"stroke-linecap",
		"stroke-linejoin",
		"stroke-miterlimit",
		"stroke-opacity",
		"stroke-width",
		"text-anchor",
		"text-decoration",
		"text-rendering",
		"underline-position",
		"underline-thickness",
		"unicode-bidi",
		"unicode-range",
		"units-per-em",
		"v-alphabetic",
		"v-hanging",
		"v-ideographic",
		"v-mathematical",
		"vector-effect",
		"vert-adv-y",
		"vert-origin-x",
		"vert-origin-y",
		"word-spacing",
		"writing-mode",
		"xmlns:xlink",
		"x-height"
	].forEach((attributeName) => {
		const name = attributeName.replace(CAMELIZE, capitalize);
		properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
	});
	[
		"xlink:actuate",
		"xlink:arcrole",
		"xlink:role",
		"xlink:show",
		"xlink:title",
		"xlink:type"
	].forEach((attributeName) => {
		const name = attributeName.replace(CAMELIZE, capitalize);
		properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
	});
	[
		"xml:base",
		"xml:lang",
		"xml:space"
	].forEach((attributeName) => {
		const name = attributeName.replace(CAMELIZE, capitalize);
		properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
	});
	["tabIndex", "crossOrigin"].forEach((attributeName) => {
		properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
	});
	var xlinkHref = "xlinkHref";
	properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
	[
		"src",
		"href",
		"action",
		"formAction"
	].forEach((attributeName) => {
		properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
	});
	var { CAMELCASE, SAME, possibleStandardNames: possibleStandardNamesOptimized } = require_possibleStandardNamesOptimized();
	/**
	* Checks whether a property name is a custom attribute.
	*
	* @see https://github.com/facebook/react/blob/15-stable/src/renderers/dom/shared/HTMLDOMPropertyConfig.js#L23-L25
	*
	* @type {(attribute: string) => boolean}
	*/
	var isCustomAttribute = RegExp.prototype.test.bind(/* @__PURE__ */ new RegExp("^(data|aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"));
	/**
	* @type {Record<string, string>}
	*/
	var possibleStandardNames = Object.keys(possibleStandardNamesOptimized).reduce((accumulator, standardName) => {
		const propName = possibleStandardNamesOptimized[standardName];
		if (propName === SAME) accumulator[standardName] = standardName;
		else if (propName === CAMELCASE) accumulator[standardName.toLowerCase()] = standardName;
		else accumulator[standardName] = propName;
		return accumulator;
	}, {});
	exports.BOOLEAN = BOOLEAN;
	exports.BOOLEANISH_STRING = BOOLEANISH_STRING;
	exports.NUMERIC = NUMERIC;
	exports.OVERLOADED_BOOLEAN = OVERLOADED_BOOLEAN;
	exports.POSITIVE_NUMERIC = POSITIVE_NUMERIC;
	exports.RESERVED = RESERVED;
	exports.STRING = STRING;
	exports.getPropertyInfo = getPropertyInfo;
	exports.isCustomAttribute = isCustomAttribute;
	exports.possibleStandardNames = possibleStandardNames;
}));
//#endregion
//#region builtin:esm-external-require-react
var require_builtin_esm_external_require_react = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	module.exports = Object.prototype.hasOwnProperty.call(m, "module.exports") ? m["module.exports"] : { ...m };
}));
//#endregion
//#region ../../../../../node_modules/inline-style-parser/cjs/index.js
var require_cjs$2 = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
	var NEWLINE_REGEX = /\n/g;
	var WHITESPACE_REGEX = /^\s*/;
	var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
	var COLON_REGEX = /^:\s*/;
	var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
	var SEMICOLON_REGEX = /^[;\s]*/;
	var TRIM_REGEX = /^\s+|\s+$/g;
	var NEWLINE = "\n";
	var FORWARD_SLASH = "/";
	var ASTERISK = "*";
	var EMPTY_STRING = "";
	var TYPE_COMMENT = "comment";
	var TYPE_DECLARATION = "declaration";
	/**
	* @param {String} style
	* @param {Object} [options]
	* @return {Object[]}
	* @throws {TypeError}
	* @throws {Error}
	*/
	function index(style, options) {
		if (typeof style !== "string") throw new TypeError("First argument must be a string");
		if (!style) return [];
		options = options || {};
		/**
		* Positional.
		*/
		var lineno = 1;
		var column = 1;
		/**
		* Update lineno and column based on `str`.
		*
		* @param {String} str
		*/
		function updatePosition(str) {
			var lines = str.match(NEWLINE_REGEX);
			if (lines) lineno += lines.length;
			var i = str.lastIndexOf(NEWLINE);
			column = ~i ? str.length - i : column + str.length;
		}
		/**
		* Mark position and patch `node.position`.
		*
		* @return {Function}
		*/
		function position() {
			var start = {
				line: lineno,
				column
			};
			return function(node) {
				node.position = new Position(start);
				whitespace();
				return node;
			};
		}
		/**
		* Store position information for a node.
		*
		* @constructor
		* @property {Object} start
		* @property {Object} end
		* @property {undefined|String} source
		*/
		function Position(start) {
			this.start = start;
			this.end = {
				line: lineno,
				column
			};
			this.source = options.source;
		}
		/**
		* Non-enumerable source string.
		*/
		Position.prototype.content = style;
		/**
		* Error `msg`.
		*
		* @param {String} msg
		* @throws {Error}
		*/
		function error(msg) {
			var err = /* @__PURE__ */ new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
			err.reason = msg;
			err.filename = options.source;
			err.line = lineno;
			err.column = column;
			err.source = style;
			if (options.silent);
			else throw err;
		}
		/**
		* Match `re` and return captures.
		*
		* @param {RegExp} re
		* @return {undefined|Array}
		*/
		function match(re) {
			var m = re.exec(style);
			if (!m) return;
			var str = m[0];
			updatePosition(str);
			style = style.slice(str.length);
			return m;
		}
		/**
		* Parse whitespace.
		*/
		function whitespace() {
			match(WHITESPACE_REGEX);
		}
		/**
		* Parse comments.
		*
		* @param {Object[]} [rules]
		* @return {Object[]}
		*/
		function comments(rules) {
			var c;
			rules = rules || [];
			while (c = comment()) if (c !== false) rules.push(c);
			return rules;
		}
		/**
		* Parse comment.
		*
		* @return {Object}
		* @throws {Error}
		*/
		function comment() {
			var pos = position();
			if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;
			var i = 2;
			while (EMPTY_STRING != style.charAt(i) && (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))) ++i;
			i += 2;
			if (EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
			var str = style.slice(2, i - 2);
			column += 2;
			updatePosition(str);
			style = style.slice(i);
			column += 2;
			return pos({
				type: TYPE_COMMENT,
				comment: str
			});
		}
		/**
		* Parse declaration.
		*
		* @return {Object}
		* @throws {Error}
		*/
		function declaration() {
			var pos = position();
			var prop = match(PROPERTY_REGEX);
			if (!prop) return;
			comment();
			if (!match(COLON_REGEX)) return error("property missing ':'");
			var val = match(VALUE_REGEX);
			var ret = pos({
				type: TYPE_DECLARATION,
				property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
				value: val ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING)) : EMPTY_STRING
			});
			match(SEMICOLON_REGEX);
			return ret;
		}
		/**
		* Parse declarations.
		*
		* @return {Object[]}
		*/
		function declarations() {
			var decls = [];
			comments(decls);
			var decl;
			while (decl = declaration()) if (decl !== false) {
				decls.push(decl);
				comments(decls);
			}
			return decls;
		}
		whitespace();
		return declarations();
	}
	/**
	* Trim `str`.
	*
	* @param {String} str
	* @return {String}
	*/
	function trim(str) {
		return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
	}
	module.exports = index;
}));
//#endregion
//#region ../../../../../node_modules/style-to-object/cjs/index.js
var require_cjs$1 = /* @__PURE__ */ __commonJSMin(((exports, module, this$5) => {
	var __importDefault = this$5 && this$5.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = StyleToObject;
	var inline_style_parser_1 = __importDefault(require_cjs$2());
	/**
	* Parses inline style to object.
	*
	* @param style - Inline style.
	* @param iterator - Iterator.
	* @returns - Style object or null.
	*
	* @example Parsing inline style to object:
	*
	* ```js
	* import parse from 'style-to-object';
	* parse('line-height: 42;'); // { 'line-height': '42' }
	* ```
	*/
	function StyleToObject(style, iterator) {
		let styleObject = null;
		if (!style || typeof style !== "string") return styleObject;
		const declarations = (0, inline_style_parser_1.default)(style);
		const hasIterator = typeof iterator === "function";
		declarations.forEach((declaration) => {
			if (declaration.type !== "declaration") return;
			const { property, value } = declaration;
			if (hasIterator) iterator(property, value, declaration);
			else if (value) {
				styleObject = styleObject || {};
				styleObject[property] = value;
			}
		});
		return styleObject;
	}
}));
//#endregion
//#region ../../../../../node_modules/style-to-js/cjs/utilities.js
var require_utilities$1 = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.camelCase = void 0;
	var CUSTOM_PROPERTY_REGEX = /^--[a-zA-Z0-9_-]+$/;
	var HYPHEN_REGEX = /-([a-z])/g;
	var NO_HYPHEN_REGEX = /^[^-]+$/;
	var VENDOR_PREFIX_REGEX = /^-(webkit|moz|ms|o|khtml)-/;
	var MS_VENDOR_PREFIX_REGEX = /^-(ms)-/;
	/**
	* Checks whether to skip camelCase.
	*/
	var skipCamelCase = function(property) {
		return !property || NO_HYPHEN_REGEX.test(property) || CUSTOM_PROPERTY_REGEX.test(property);
	};
	/**
	* Replacer that capitalizes first character.
	*/
	var capitalize = function(match, character) {
		return character.toUpperCase();
	};
	/**
	* Replacer that removes beginning hyphen of vendor prefix property.
	*/
	var trimHyphen = function(match, prefix) {
		return "".concat(prefix, "-");
	};
	/**
	* CamelCases a CSS property.
	*/
	var camelCase = function(property, options) {
		if (options === void 0) options = {};
		if (skipCamelCase(property)) return property;
		property = property.toLowerCase();
		if (options.reactCompat) property = property.replace(MS_VENDOR_PREFIX_REGEX, trimHyphen);
		else property = property.replace(VENDOR_PREFIX_REGEX, trimHyphen);
		return property.replace(HYPHEN_REGEX, capitalize);
	};
	exports.camelCase = camelCase;
}));
//#endregion
//#region ../../../../../node_modules/style-to-js/cjs/index.js
var require_cjs = /* @__PURE__ */ __commonJSMin(((exports, module, this$4) => {
	var style_to_object_1 = (this$4 && this$4.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	})(require_cjs$1());
	var utilities_1 = require_utilities$1();
	/**
	* Parses CSS inline style to JavaScript object (camelCased).
	*/
	function StyleToJS(style, options) {
		var output = {};
		if (!style || typeof style !== "string") return output;
		(0, style_to_object_1.default)(style, function(property, value) {
			if (property && value) output[(0, utilities_1.camelCase)(property, options)] = value;
		});
		return output;
	}
	StyleToJS.default = StyleToJS;
	module.exports = StyleToJS;
}));
//#endregion
//#region ../../../../../node_modules/html-react-parser/lib/utilities.js
var require_utilities = /* @__PURE__ */ __commonJSMin(((exports, module, this$3) => {
	var __importDefault = this$3 && this$3.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.returnFirstArg = exports.canTextBeChildOfNode = exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = exports.PRESERVE_CUSTOM_ATTRIBUTES = void 0;
	exports.isCustomComponent = isCustomComponent;
	exports.setStyleProp = setStyleProp;
	var react_1 = require_builtin_esm_external_require_react();
	var style_to_js_1 = __importDefault(require_cjs());
	var RESERVED_SVG_MATHML_ELEMENTS = /* @__PURE__ */ new Set([
		"annotation-xml",
		"color-profile",
		"font-face",
		"font-face-src",
		"font-face-uri",
		"font-face-format",
		"font-face-name",
		"missing-glyph"
	]);
	/**
	* Check if a tag is a custom component.
	*
	* @see {@link https://github.com/facebook/react/blob/v16.6.3/packages/react-dom/src/shared/isCustomComponent.js}
	*
	* @param tagName - Tag name.
	* @param props - Props passed to the element.
	* @returns - Whether the tag is custom component.
	*/
	function isCustomComponent(tagName, props) {
		if (!tagName.includes("-")) return Boolean(props && typeof props.is === "string");
		if (RESERVED_SVG_MATHML_ELEMENTS.has(tagName)) return false;
		return true;
	}
	var styleOptions = { reactCompat: true };
	/**
	* Sets style prop.
	*
	* @param style - Inline style.
	* @param props - Props object.
	*/
	function setStyleProp(style, props) {
		if (typeof style !== "string") return;
		if (!style.trim()) {
			props.style = {};
			return;
		}
		try {
			props.style = (0, style_to_js_1.default)(style, styleOptions);
		} catch (error) {
			props.style = {};
		}
	}
	/**
	* @see https://reactjs.org/blog/2017/09/08/dom-attributes-in-react-16.html
	*/
	exports.PRESERVE_CUSTOM_ATTRIBUTES = Number(react_1.version.split(".")[0]) >= 16;
	/**
	* @see https://github.com/facebook/react/blob/cae635054e17a6f107a39d328649137b83f25972/packages/react-dom/src/client/validateDOMNesting.js#L213
	*/
	exports.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
		"tr",
		"tbody",
		"thead",
		"tfoot",
		"colgroup",
		"table",
		"head",
		"html",
		"frameset"
	]);
	/**
	* Checks if the given node can contain text nodes
	*
	* @param node - Element node.
	* @returns - Whether the node can contain text nodes.
	*/
	var canTextBeChildOfNode = function(node) {
		return !exports.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(node.name);
	};
	exports.canTextBeChildOfNode = canTextBeChildOfNode;
	/**
	* Returns the first argument as is.
	*
	* @param arg - The argument to be returned.
	* @returns - The input argument `arg`.
	*/
	var returnFirstArg = function(arg) {
		return arg;
	};
	exports.returnFirstArg = returnFirstArg;
}));
//#endregion
//#region ../../../../../node_modules/html-react-parser/lib/attributes-to-props.js
var require_attributes_to_props = /* @__PURE__ */ __commonJSMin(((exports) => {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = attributesToProps;
	var react_property_1 = require_lib$1();
	var utilities_1 = require_utilities();
	var UNCONTROLLED_COMPONENT_ATTRIBUTES = ["checked", "value"];
	var UNCONTROLLED_COMPONENT_NAMES = [
		"input",
		"select",
		"textarea"
	];
	var valueOnlyInputs = {
		reset: true,
		submit: true
	};
	/**
	* Converts HTML/SVG DOM attributes to React props.
	*
	* @param attributes - HTML/SVG DOM attributes.
	* @param nodeName - DOM node name.
	* @returns - React props.
	*/
	function attributesToProps(attributes, nodeName) {
		if (attributes === void 0) attributes = {};
		var props = {};
		var isInputValueOnly = Boolean(attributes.type && valueOnlyInputs[attributes.type]);
		for (var attributeName in attributes) {
			var attributeValue = attributes[attributeName];
			if ((0, react_property_1.isCustomAttribute)(attributeName)) {
				props[attributeName] = attributeValue;
				continue;
			}
			var attributeNameLowerCased = attributeName.toLowerCase();
			var propName = getPropName(attributeNameLowerCased);
			if (propName) {
				var propertyInfo = (0, react_property_1.getPropertyInfo)(propName);
				if (UNCONTROLLED_COMPONENT_ATTRIBUTES.includes(propName) && UNCONTROLLED_COMPONENT_NAMES.includes(nodeName) && !isInputValueOnly) propName = getPropName("default" + attributeNameLowerCased);
				props[propName] = attributeValue;
				switch (propertyInfo && propertyInfo.type) {
					case react_property_1.BOOLEAN:
						props[propName] = true;
						break;
					case react_property_1.OVERLOADED_BOOLEAN: if (attributeValue === "") props[propName] = true;
				}
				continue;
			}
			if (utilities_1.PRESERVE_CUSTOM_ATTRIBUTES) props[attributeName] = attributeValue;
		}
		(0, utilities_1.setStyleProp)(attributes.style, props);
		return props;
	}
	/**
	* Gets prop name from lowercased attribute name.
	*
	* @param attributeName - Lowercased attribute name.
	* @returns - Prop name.
	*/
	function getPropName(attributeName) {
		return react_property_1.possibleStandardNames[attributeName];
	}
}));
//#endregion
//#region ../../../../../node_modules/html-react-parser/lib/dom-to-react.js
var require_dom_to_react = /* @__PURE__ */ __commonJSMin(((exports, module, this$2) => {
	var __importDefault = this$2 && this$2.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.default = domToReact;
	var react_1 = require_builtin_esm_external_require_react();
	var attributes_to_props_1 = __importDefault(require_attributes_to_props());
	var utilities_1 = require_utilities();
	var React = {
		cloneElement: react_1.cloneElement,
		createElement: react_1.createElement,
		isValidElement: react_1.isValidElement
	};
	/**
	* Converts DOM nodes to JSX element(s).
	*
	* @param nodes - DOM nodes.
	* @param options - Options.
	* @returns - String or JSX element(s).
	*/
	function domToReact(nodes, options) {
		if (options === void 0) options = {};
		var reactElements = [];
		var hasReplace = typeof options.replace === "function";
		var transform = options.transform || utilities_1.returnFirstArg;
		var _a = options.library || React, cloneElement = _a.cloneElement, createElement = _a.createElement, isValidElement = _a.isValidElement;
		var nodesLength = nodes.length;
		for (var index = 0; index < nodesLength; index++) {
			var node = nodes[index];
			if (hasReplace) {
				var replaceElement = options.replace(node, index);
				if (isValidElement(replaceElement)) {
					if (nodesLength > 1) replaceElement = cloneElement(replaceElement, { key: replaceElement.key || index });
					reactElements.push(transform(replaceElement, node, index));
					continue;
				}
			}
			if (node.type === "text") {
				var isWhitespace = !node.data.trim().length;
				if (isWhitespace && node.parent && !(0, utilities_1.canTextBeChildOfNode)(node.parent)) continue;
				if (options.trim && isWhitespace) continue;
				reactElements.push(transform(node.data, node, index));
				continue;
			}
			var element = node;
			var props = {};
			if (skipAttributesToProps(element)) {
				(0, utilities_1.setStyleProp)(element.attribs.style, element.attribs);
				props = element.attribs;
			} else if (element.attribs) props = (0, attributes_to_props_1.default)(element.attribs, element.name);
			var children = void 0;
			switch (node.type) {
				case "script":
				case "style":
					if (node.children[0]) props.dangerouslySetInnerHTML = { __html: node.children[0].data };
					break;
				case "tag":
					if (node.name === "textarea" && node.children[0]) props.defaultValue = node.children[0].data;
					else if (node.children && node.children.length) children = domToReact(node.children, options);
					break;
				default: continue;
			}
			if (nodesLength > 1) props.key = index;
			reactElements.push(transform(createElement(node.name, props, children), node, index));
		}
		return reactElements.length === 1 ? reactElements[0] : reactElements;
	}
	/**
	* Determines whether DOM element attributes should be transformed to props.
	* Web Components should not have their attributes transformed except for `style`.
	*
	* @param node - Element node.
	* @returns - Whether the node attributes should be converted to props.
	*/
	function skipAttributesToProps(node) {
		return utilities_1.PRESERVE_CUSTOM_ATTRIBUTES && node.type === "tag" && (0, utilities_1.isCustomComponent)(node.name, node.attribs);
	}
}));
//#endregion
//#region ../../../../../node_modules/html-react-parser/esm/index.mjs
var import_lib = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module, this$1) => {
	var __importDefault = this$1 && this$1.__importDefault || function(mod) {
		return mod && mod.__esModule ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.htmlToDOM = exports.domToReact = exports.attributesToProps = exports.Text = exports.ProcessingInstruction = exports.Element = exports.Comment = void 0;
	exports.default = HTMLReactParser;
	var html_dom_parser_1 = __importDefault(require_html_to_dom());
	exports.htmlToDOM = html_dom_parser_1.default;
	exports.attributesToProps = __importDefault(require_attributes_to_props()).default;
	var dom_to_react_1 = __importDefault(require_dom_to_react());
	exports.domToReact = dom_to_react_1.default;
	var domhandler_1 = require_lib$2();
	Object.defineProperty(exports, "Comment", {
		enumerable: true,
		get: function() {
			return domhandler_1.Comment;
		}
	});
	Object.defineProperty(exports, "Element", {
		enumerable: true,
		get: function() {
			return domhandler_1.Element;
		}
	});
	Object.defineProperty(exports, "ProcessingInstruction", {
		enumerable: true,
		get: function() {
			return domhandler_1.ProcessingInstruction;
		}
	});
	Object.defineProperty(exports, "Text", {
		enumerable: true,
		get: function() {
			return domhandler_1.Text;
		}
	});
	var domParserOptions = { lowerCaseAttributeNames: false };
	/**
	* Converts HTML string to React elements.
	*
	* @param html - HTML string.
	* @param options - Parser options.
	* @returns - React element(s), empty array, or string.
	*/
	function HTMLReactParser(html, options) {
		if (typeof html !== "string") throw new TypeError("First argument must be a string");
		if (!html) return [];
		return (0, dom_to_react_1.default)((0, html_dom_parser_1.default)(html, (options === null || options === void 0 ? void 0 : options.htmlparser2) || domParserOptions), options);
	}
})))(), 1);
var esm_default = import_lib.default.default || import_lib.default;
//#endregion
//#region src/raw-html.tsx
function RawHtml({ code }) {
	const { content = "", scripts = [] } = code ?? {};
	const [scriptInitialized, setScriptInitialized] = useState();
	const scriptsContent = useMemo(() => {
		return scripts.map((src) => {
			if (!src) return null;
			const key = md5(src);
			return /* @__PURE__ */ jsx(Script, {
				src,
				onload: () => {
					setScriptInitialized((s) => ({
						...s,
						[src]: true
					}));
				}
			}, `script-${key}`);
		});
	}, [scripts]);
	useEffect(() => {
		for (const src in scriptInitialized) {
			if (!scriptInitialized[src]) continue;
			if (src.includes("widget.trustpilot.com")) each(document.querySelectorAll(".trustpilot-widget"), (el) => {
				window.Trustpilot.loadFromElement(el);
			});
		}
	}, [scriptInitialized]);
	return /* @__PURE__ */ jsxs(Fragment, { children: [content ? esm_default(content) : null, scriptsContent] });
}
//#endregion
//#region ../../styled-system/styled-system/helpers.js
function isObject(v) {
	return typeof v === "object" && v != null && !Array.isArray(v);
}
var HAS_OWN = Object.prototype.hasOwnProperty;
function isBaseCondition(v) {
	return v === "base";
}
function filterBaseConditions(c) {
	const out = [];
	for (let i = 0; i < c.length; i++) if (!isBaseCondition(c[i])) out.push(c[i]);
	return out;
}
function toHash(v) {
	let h = 5381;
	for (let i = v.length; i;) h = h * 33 ^ v.charCodeAt(--i);
	let x = h >>> 0, out = "";
	for (; x > 52; x = x / 52 | 0) {
		const c = x % 52;
		out = String.fromCharCode(c + (c > 25 ? 39 : 97)) + out;
	}
	const c = x % 52;
	return String.fromCharCode(c + (c > 25 ? 39 : 97)) + out;
}
function toCssVar(path) {
	return "var(--" + toHash(path.replaceAll(".", "-")) + ")";
}
function colorMix(tokens, path, resolveVar) {
	if (!path.startsWith("colors.")) return;
	const index = path.indexOf("/", 7);
	if (index === -1 || index === path.length - 1) return;
	const colorPath = path.slice(0, index);
	if (tokens[colorPath] === void 0) return;
	const rawOpacity = path.slice(index + 1);
	const opacity = tokens["opacity." + rawOpacity];
	const percent = opacity === void 0 ? Number(rawOpacity) : Number(opacity) * 100;
	if (Number.isNaN(percent)) return;
	return "color-mix(in oklab, " + (resolveVar || toCssVar)(colorPath) + " " + percent + "%, transparent)";
}
function compact(v) {
	const out = {};
	if (!v) return out;
	for (const k in v) if (v[k] !== void 0) out[k] = v[k];
	return out;
}
function withDefaults(defaults, props) {
	return {
		...defaults,
		...compact(props)
	};
}
function toVariantMap(variants) {
	const map = {};
	for (const key in variants) map[key] = Object.keys(variants[key]);
	return map;
}
function compoundVariantMatches(compound, variants) {
	for (const key in compound) {
		if (key === "css" || key === "className" || key === "classNames") continue;
		const expected = compound[key];
		const actual = variants[key];
		if (Array.isArray(expected) ? !expected.includes(actual) : actual !== expected) return false;
	}
	return true;
}
function getCompoundVariantCss(compoundVariants, variants) {
	let result = {};
	for (const variant of compoundVariants) {
		if (!compoundVariantMatches(variant, variants)) continue;
		result = mergeProps(result, variant.css);
	}
	return result;
}
function toResponsiveObject(values, breakpoints) {
	const out = {};
	for (let i = 0; i < values.length; i++) if (values[i] != null) out[breakpoints[i]] = values[i];
	return out;
}
function walkObject(target, fn, options) {
	options ||= {};
	const { stop, getKey } = options;
	const inner = (value, path = []) => {
		if (!value || typeof value !== "object") return fn(value, path);
		if (stop?.(value, path)) return fn(value, path);
		const out = Array.isArray(value) ? [] : {};
		for (const prop in value) {
			if (!HAS_OWN.call(value, prop) || prop === "__proto__") continue;
			const key = getKey?.(prop, value[prop]) ?? prop;
			path.push(key);
			const next = inner(value[prop], path);
			path.pop();
			if (next != null) out[key] = next;
		}
		return out;
	};
	return inner(target);
}
function normalizeStyleObject(styles, context, shorthand) {
	const { utility, conditions } = context;
	const { hasShorthand, resolveShorthand } = utility;
	shorthand = shorthand !== false;
	return walkObject(styles, (value) => {
		if (Array.isArray(value)) return toResponsiveObject(value, conditions.breakpoints.keys);
		return value;
	}, {
		stop: Array.isArray,
		getKey: shorthand ? (prop) => hasShorthand ? resolveShorthand(prop) : prop : void 0
	});
}
function flatHashOrNull(args) {
	let h = 5381;
	for (let a = 0; a < args.length; a++) {
		const obj = args[a];
		if (obj === null || typeof obj !== "object") {
			h = h * 33 ^ 1;
			continue;
		}
		for (const k in obj) {
			const v = obj[k];
			const tv = typeof v;
			if (v !== null && tv === "object") return null;
			for (let i = 0; i < k.length; i++) h = h * 33 ^ k.charCodeAt(i);
			if (tv === "string") for (let i = 0; i < v.length; i++) h = h * 33 ^ v.charCodeAt(i);
			else if (tv === "number") h = h * 33 ^ (v | 0);
			else if (tv === "boolean") h = h * 33 ^ (v ? 991 : 997);
			else h = h * 33 ^ 2;
		}
	}
	return h >>> 0;
}
function flatArgsEqual(a, b) {
	if (a.length !== b.length) return false;
	for (let i = 0; i < a.length; i++) {
		const oa = a[i];
		const ob = b[i];
		if (oa === ob) continue;
		if (oa === null || ob === null || typeof oa !== "object" || typeof ob !== "object") return false;
		let n = 0;
		for (const k in oa) {
			if (oa[k] !== ob[k]) return false;
			n++;
		}
		if (n !== Object.keys(ob).length) return false;
	}
	return true;
}
function memo(fn) {
	const cache = /* @__PURE__ */ new Map();
	const stringCache = /* @__PURE__ */ new Map();
	const seen = /* @__PURE__ */ new WeakSet();
	const newNode = () => ({
		objects: /* @__PURE__ */ new WeakMap(),
		prims: /* @__PURE__ */ new Map(),
		out: void 0,
		has: false
	});
	const root = newNode();
	let lastHash;
	let lastKey;
	let lastValue;
	let hasLast = false;
	let misses = 0;
	const step = (node, v) => {
		if (v !== null && typeof v === "object") {
			let next = node.objects.get(v);
			if (next === void 0) {
				next = newNode();
				node.objects.set(v, next);
			}
			return next;
		}
		let next = node.prims.get(v);
		if (next === void 0) {
			if (node.prims.size > 64) node.prims.clear();
			next = newNode();
			node.prims.set(v, next);
		}
		return next;
	};
	const walk = (node, v) => {
		if (Array.isArray(v)) {
			node = step(node, "\0[");
			for (let i = 0; i < v.length; i++) node = walk(node, v[i]);
			return step(node, "\0]");
		}
		return step(node, v);
	};
	const readWalk = (node, v) => {
		if (node === void 0) return void 0;
		if (Array.isArray(v)) {
			node = node.prims.get("\0[");
			for (let i = 0; i < v.length && node !== void 0; i++) node = readWalk(node, v[i]);
			return node === void 0 ? void 0 : node.prims.get("\0]");
		}
		return v !== null && typeof v === "object" ? node.objects.get(v) : node.prims.get(v);
	};
	const markSeen = (v) => {
		if (Array.isArray(v)) {
			let all = true;
			for (let i = 0; i < v.length; i++) if (!markSeen(v[i])) all = false;
			return all;
		}
		if (v === null || typeof v !== "object") return true;
		if (seen.has(v)) return true;
		seen.add(v);
		return false;
	};
	return ((...args) => {
		let composed = false;
		for (let i = 0; i < args.length; i++) if (Array.isArray(args[i])) {
			composed = true;
			break;
		}
		if (composed) {
			let node = root;
			for (let i = 0; i < args.length && node !== void 0; i++) node = readWalk(node, args[i]);
			if (node !== void 0 && node.has) return node.out;
			const composedKey = JSON.stringify(args);
			let composedOut = hasLast && lastHash === void 0 && composedKey === lastKey ? lastValue : stringCache.get(composedKey);
			if (composedOut === void 0) {
				composedOut = fn(...args);
				stringCache.set(composedKey, composedOut);
				if (stringCache.size > 500) stringCache.delete(stringCache.keys().next().value);
			}
			let reused = false;
			if ((++misses & 3) === 0) {
				reused = true;
				for (let i = 0; i < args.length; i++) if (!markSeen(args[i])) reused = false;
			}
			if (reused) {
				let insert = root;
				for (let i = 0; i < args.length; i++) insert = walk(insert, args[i]);
				insert.out = composedOut;
				insert.has = true;
			}
			lastHash = void 0;
			lastKey = composedKey;
			lastValue = composedOut;
			hasLast = true;
			return composedOut;
		}
		const hash = flatHashOrNull(args);
		if (hash !== null) {
			if (hasLast && lastHash === hash && flatArgsEqual(args, lastKey)) return lastValue;
			let bucket = cache.get(hash);
			if (bucket) {
				for (let i = 0; i < bucket.length; i++) if (flatArgsEqual(args, bucket[i].args)) {
					lastHash = hash;
					lastKey = args;
					lastValue = bucket[i].out;
					hasLast = true;
					return bucket[i].out;
				}
			}
			const out = fn(...args);
			if (!bucket) {
				bucket = [];
				cache.set(hash, bucket);
			}
			bucket.push({
				args,
				out
			});
			if (bucket.length > 8) bucket.shift();
			if (cache.size > 500) cache.delete(cache.keys().next().value);
			lastHash = hash;
			lastKey = args;
			lastValue = out;
			hasLast = true;
			return out;
		}
		const key = JSON.stringify(args);
		if (hasLast && lastHash === void 0 && key === lastKey) return lastValue;
		const cached = stringCache.get(key);
		if (cached !== void 0) {
			lastHash = void 0;
			lastKey = key;
			lastValue = cached;
			hasLast = true;
			return cached;
		}
		const out = fn(...args);
		stringCache.set(key, out);
		if (stringCache.size > 500) stringCache.delete(stringCache.keys().next().value);
		lastHash = void 0;
		lastKey = key;
		lastValue = out;
		hasLast = true;
		return out;
	});
}
function weakMemo(fn) {
	const cache = /* @__PURE__ */ new WeakMap();
	return ((arg) => {
		if (!arg || typeof arg !== "object") return fn(arg);
		if (cache.has(arg)) return cache.get(arg);
		const out = fn(arg);
		cache.set(arg, out);
		return out;
	});
}
function mergeProps(...src) {
	const out = {};
	for (const obj of src) {
		if (!obj) continue;
		for (const k in obj) {
			if (!HAS_OWN.call(obj, k) || k === "__proto__" || k === "constructor" || k === "prototype") continue;
			const prev = out[k];
			const next = obj[k];
			out[k] = isObject(prev) && isObject(next) ? mergeProps(prev, next) : next;
		}
	}
	return out;
}
var WHITESPACE_REGEX = /[\n\s]+/g;
var sanitizeStyleValue = (value) => typeof value === "string" ? value.replace(WHITESPACE_REGEX, " ") : value;
function resolveStyleArgs(styles, context) {
	const out = [];
	const visit = (items) => {
		for (let i = 0; i < items.length; i++) {
			const style = items[i];
			if (Array.isArray(style)) {
				visit(style);
				continue;
			}
			if (!isObject(style)) continue;
			for (const key in style) if (style[key] !== void 0) {
				out.push(style);
				break;
			}
		}
	};
	visit(styles);
	if (out.length < 2) return out;
	for (let i = 0; i < out.length; i++) out[i] = normalizeStyleObject(out[i], context);
	return out;
}
function createSerializeCss(context) {
	const u = context.utility;
	const c = context.conditions;
	const hash = context.hash;
	const fmt = (s) => u.prefix ? u.prefix + "-" + s : s;
	const toClass = (paths, name) => {
		const parts = c.finalize(paths);
		parts.push(hash ? name : fmt(name));
		return hash ? fmt(u.toHash(parts, toHash)) : parts.join(":");
	};
	return weakMemo(memo(function serializeCss({ base, ...styles } = {}) {
		const obj = normalizeStyleObject(base ? Object.assign(styles, base) : styles, context);
		const set = /* @__PURE__ */ new Set();
		walkObject(obj, (value, paths) => {
			if (value == null) return;
			const important = isImportant(value);
			const [prop, ...all] = c.shift(paths);
			const cond = filterBaseConditions(all);
			const res = u.transform(prop, withoutSpace(withoutImportant(sanitizeStyleValue(value))));
			let name = toClass(cond, res.className);
			if (important) name += "!";
			set.add(name);
		});
		let out = "";
		for (const name of set) out += out ? " " + name : name;
		return out;
	}));
}
function createMergeCss(context) {
	return function mergeCss() {
		return mergeProps(...resolveStyleArgs(arguments, context));
	};
}
function createSerializeCssArgs(serializeCss, mergeCss) {
	return memo(function serializeCssArgs(...styles) {
		return serializeCss(mergeCss(...styles));
	});
}
var HYPHENATE_PROPERTY_REGEX = /[A-Z]/g;
var MS_PROPERTY_REGEX = /^ms-/;
function hypenateProperty(property) {
	return property.startsWith("--") ? property : property.replace(HYPHENATE_PROPERTY_REGEX, "-$&").replace(MS_PROPERTY_REGEX, "-ms-").toLowerCase();
}
var splitPropsKeyMapCache = /* @__PURE__ */ new WeakMap();
function getSplitPropsKeyMap(keys) {
	let keyMap = splitPropsKeyMapCache.get(keys);
	if (keyMap) return keyMap;
	keyMap = Object.create(null);
	for (let i = 0; i < keys.length; i++) keyMap[keys[i]] = true;
	splitPropsKeyMapCache.set(keys, keyMap);
	return keyMap;
}
function copySplitProp(source, target, key) {
	const desc = Object.getOwnPropertyDescriptor(source, key);
	if (desc?.get || desc?.set) {
		Object.defineProperty(target, key, desc);
		return;
	}
	target[key] = source[key];
}
function splitProps(props, ...keys) {
	const propKeys = Object.keys(props);
	const keyCount = keys.length;
	if (keyCount === 1) {
		const matcher = keys[0];
		const picked = {};
		const rest = {};
		if (Array.isArray(matcher)) {
			const keyMap = getSplitPropsKeyMap(matcher);
			for (let i = 0; i < propKeys.length; i++) {
				const key = propKeys[i];
				if (keyMap[key] === true) copySplitProp(props, picked, key);
				else copySplitProp(props, rest, key);
			}
			return [picked, rest];
		}
		for (let i = 0; i < propKeys.length; i++) {
			const key = propKeys[i];
			if (matcher(key)) copySplitProp(props, picked, key);
			else copySplitProp(props, rest, key);
		}
		return [picked, rest];
	}
	const matchers = new Array(keyCount);
	for (let i = 0; i < keyCount; i++) {
		const matcher = keys[i];
		matchers[i] = Array.isArray(matcher) ? getSplitPropsKeyMap(matcher) : matcher;
	}
	const out = new Array(keyCount + 1);
	for (let i = 0; i <= keyCount; i++) out[i] = {};
	const rest = out[keyCount];
	for (let i = 0; i < propKeys.length; i++) {
		const key = propKeys[i];
		let matched = false;
		for (let j = 0; j < keyCount; j++) {
			const matcher = matchers[j];
			if (typeof matcher === "function" ? matcher(key) : matcher[key] === true) {
				copySplitProp(props, out[j], key);
				matched = true;
				break;
			}
		}
		if (!matched) copySplitProp(props, rest, key);
	}
	return out;
}
function uniq(...items) {
	const set = /* @__PURE__ */ new Set();
	for (const values of items) {
		if (!values) continue;
		for (let i = 0; i < values.length; i++) set.add(values[i]);
	}
	return Array.from(set);
}
function withoutSpace(str) {
	return typeof str === "string" && str.indexOf(" ") >= 0 ? str.replaceAll(" ", "_") : str;
}
var IMPORTANT_REGEX = /\s*!(important)?\s*$/i;
function isImportant(value) {
	return typeof value === "string" ? IMPORTANT_REGEX.test(value) : false;
}
function withoutImportant(value) {
	return typeof value === "string" ? value.replace(IMPORTANT_REGEX, "").trim() : value;
}
//#endregion
//#region ../../styled-system/styled-system/css/conditions.js
var conditions = /* @__PURE__ */ new Set(/* @__PURE__ */ "2xl,2xlDown,2xlOnly,2xlToDesktop,2xlToTablet,2xlToXs,@/2xl,@/2xlDown,@/2xlOnly,@/2xlTo3xl,@/2xlTo4xl,@/2xlTo5xl,@/2xlTo6xl,@/2xlTo7xl,@/2xlTo8xl,@/2xs,@/2xsDown,@/2xsOnly,@/2xsTo2xl,@/2xsTo3xl,@/2xsTo4xl,@/2xsTo5xl,@/2xsTo6xl,@/2xsTo7xl,@/2xsTo8xl,@/2xsToLg,@/2xsToMd,@/2xsToSm,@/2xsToXl,@/2xsToXs,@/3xl,@/3xlDown,@/3xlOnly,@/3xlTo4xl,@/3xlTo5xl,@/3xlTo6xl,@/3xlTo7xl,@/3xlTo8xl,@/3xs,@/3xsDown,@/3xsOnly,@/3xsTo2xl,@/3xsTo2xs,@/3xsTo3xl,@/3xsTo4xl,@/3xsTo5xl,@/3xsTo6xl,@/3xsTo7xl,@/3xsTo8xl,@/3xsToLg,@/3xsToMd,@/3xsToSm,@/3xsToXl,@/3xsToXs,@/4xl,@/4xlDown,@/4xlOnly,@/4xlTo5xl,@/4xlTo6xl,@/4xlTo7xl,@/4xlTo8xl,@/5xl,@/5xlDown,@/5xlOnly,@/5xlTo6xl,@/5xlTo7xl,@/5xlTo8xl,@/6xl,@/6xlDown,@/6xlOnly,@/6xlTo7xl,@/6xlTo8xl,@/7xl,@/7xlDown,@/7xlOnly,@/7xlTo8xl,@/8xl,@/8xlDown,@/8xlOnly,@/lg,@/lgDown,@/lgOnly,@/lgTo2xl,@/lgTo3xl,@/lgTo4xl,@/lgTo5xl,@/lgTo6xl,@/lgTo7xl,@/lgTo8xl,@/lgToXl,@/md,@/mdDown,@/mdOnly,@/mdTo2xl,@/mdTo3xl,@/mdTo4xl,@/mdTo5xl,@/mdTo6xl,@/mdTo7xl,@/mdTo8xl,@/mdToLg,@/mdToXl,@/sm,@/smDown,@/smOnly,@/smTo2xl,@/smTo3xl,@/smTo4xl,@/smTo5xl,@/smTo6xl,@/smTo7xl,@/smTo8xl,@/smToLg,@/smToMd,@/smToXl,@/xl,@/xlDown,@/xlOnly,@/xlTo2xl,@/xlTo3xl,@/xlTo4xl,@/xlTo5xl,@/xlTo6xl,@/xlTo7xl,@/xlTo8xl,@/xs,@/xsDown,@/xsOnly,@/xsTo2xl,@/xsTo3xl,@/xsTo4xl,@/xsTo5xl,@/xsTo6xl,@/xsTo7xl,@/xsTo8xl,@/xsToLg,@/xsToMd,@/xsToSm,@/xsToXl,_active,_after,_anyPointerCoarse,_anyPointerFine,_anyPointerNone,_atValue,_autofill,_backdrop,_before,_checked,_closed,_complete,_current,_currentPage,_currentStep,_dark,_default,_disabled,_dragging,_empty,_enabled,_even,_expanded,_file,_first,_firstLetter,_firstLine,_firstOfType,_focus,_focusVisible,_focusWithin,_fullscreen,_grabbed,_groupActive,_groupChecked,_groupDisabled,_groupExpanded,_groupFocus,_groupFocusVisible,_groupFocusWithin,_groupHover,_groupInvalid,_hidden,_highContrast,_highlighted,_horizontal,_hover,_icon,_inRange,_incomplete,_indeterminate,_inert,_invalid,_invertedColors,_landscape,_last,_lastOfType,_lessContrast,_light,_loading,_ltr,_marker,_moreContrast,_motionReduce,_motionSafe,_noscript,_now,_odd,_only,_onlyOfType,_open,_optional,_osDark,_osLight,_outOfRange,_overValue,_peerActive,_peerChecked,_peerDisabled,_peerExpanded,_peerFocus,_peerFocusVisible,_peerFocusWithin,_peerHover,_peerInvalid,_peerPlaceholderShown,_placeholder,_placeholderShown,_pointerCoarse,_pointerFine,_pointerNone,_portrait,_pressed,_print,_rangeEnd,_rangeStart,_readOnly,_readWrite,_required,_rtl,_scrollbar,_scrollbarThumb,_scrollbarTrack,_selected,_selection,_starting,_target,_today,_topmost,_unavailable,_underValue,_userInvalid,_userValid,_valid,_vertical,_visited,base,desktop,desktopDown,desktopOnly,lg,lgDown,lgOnly,lgTo2xl,lgToDesktop,lgToTablet,lgToXl,lgToXs,md,mdDown,mdOnly,mdTo2xl,mdToDesktop,mdToLg,mdToTablet,mdToXl,mdToXs,sm,smDown,smOnly,smTo2xl,smToDesktop,smToLg,smToMd,smToTablet,smToXl,smToXs,tablet,tabletDown,tabletOnly,tabletToDesktop,xl,xlDown,xlOnly,xlTo2xl,xlToDesktop,xlToTablet,xlToXs,xs,xsDown,xsOnly,xsToDesktop,xsToTablet".split(","));
var conditionRe = /^@|&/;
var underscoreRe = /^_/;
var selectorRe = /&|@/;
var breakpointKeys = [
	"base",
	"sm",
	"md",
	"lg",
	"xl",
	"2xl",
	"xs",
	"tablet",
	"desktop"
];
function isCondition(v) {
	return conditions.has(v) || conditionRe.test(v);
}
function finalizeConditions(paths) {
	return paths.map((p) => {
		if (conditions.has(p)) return p.replace(underscoreRe, "");
		if (selectorRe.test(p)) return `[${withoutSpace(p.trim())}]`;
		return p;
	});
}
function sortConditions(paths) {
	return [...paths].sort((a, b) => {
		const aa = isCondition(a);
		const bb = isCondition(b);
		return aa && !bb ? 1 : !aa && bb ? -1 : 0;
	});
}
//#endregion
//#region ../../styled-system/styled-system/css/css.js
var utilities = "WebkitTextFillColor:wktf-c,accentColor:ac-c,alignContent:ac,alignItems:ai,alignSelf:as,animation:anim,animationComposition:anim-comp,animationDelay:anim-dly,animationDirection:anim-dir,animationDuration:anim-dur,animationFillMode:anim-fm,animationIterationCount:anim-ic,animationName:anim-n,animationPlayState:anim-ps,animationRange:anim-r,animationRangeEnd:anim-re,animationRangeStart:anim-rs,animationState:anim-s,animationTimeline:anim-tl,animationTimingFunction:anim-tmf,appearance:ap,aspectRatio:asp,backdropBlur:bkdp-blur,backdropBrightness:bkdp-brightness,backdropContrast:bkdp-contrast,backdropFilter:bkdp,backdropGrayscale:bkdp-grayscale,backdropHueRotate:bkdp-hue-rotate,backdropInvert:bkdp-invert,backdropOpacity:bkdp-opacity,backdropSaturate:bkdp-saturate,backdropSepia:bkdp-sepia,backfaceVisibility:bfv,background:bg/1,backgroundAttachment:bg-a/bgAttachment,backgroundBlendMode:bg-bm/bgBlendMode,backgroundClip:bg-cp/bgClip,backgroundColor:bg-c/bgColor,backgroundConic:bg-conic/bgConic,backgroundGradient:bg-grad/bgGradient,backgroundImage:bg-i/bgImage,backgroundLinear:bg-linear/bgLinear,backgroundOrigin:bg-o/bgOrigin,backgroundPosition:bg-p/bgPosition,backgroundPositionX:bg-p-x/bgPositionX,backgroundPositionY:bg-p-y/bgPositionY,backgroundRadial:bg-radial/bgRadial,backgroundRepeat:bg-r/bgRepeat,backgroundSize:bg-s/bgSize,blockSize:h-bs,border:bd,borderBlock:bd-y/borderY,borderBlockColor:bd-y-c/borderYColor,borderBlockEnd:bd-be,borderBlockEndColor:bd-be-c,borderBlockEndWidth:bd-be-w,borderBlockStart:bd-bs,borderBlockStartColor:bd-bs-c,borderBlockStartWidth:bd-bs-w,borderBlockWidth:bd-y-w/borderYWidth,borderBottom:bd-b,borderBottomColor:bd-b-c,borderBottomLeftRadius:bdr-bl/roundedBottomLeft,borderBottomRadius:bdr-b/roundedBottom,borderBottomRightRadius:bdr-br/roundedBottomRight,borderBottomWidth:bd-b-w,borderCollapse:bd-cl,borderColor:bd-c,borderEndEndRadius:bdr-ee/roundedEndEnd,borderEndRadius:bdr-e/roundedEnd,borderEndStartRadius:bdr-es/roundedEndStart,borderInline:bd-x/borderX,borderInlineColor:bd-x-c/borderXColor,borderInlineEnd:bd-e/borderEnd,borderInlineEndColor:bd-e-c/borderEndColor,borderInlineEndWidth:bd-e-w/borderEndWidth,borderInlineStart:bd-s/borderStart,borderInlineStartColor:bd-s-c/borderStartColor,borderInlineStartWidth:bd-s-w/borderStartWidth,borderInlineWidth:bd-x-w/borderXWidth,borderLeft:bd-l,borderLeftColor:bd-l-c,borderLeftRadius:bdr-l/roundedLeft,borderLeftWidth:bd-l-w,borderRadius:bdr/rounded,borderRight:bd-r,borderRightColor:bd-r-c,borderRightRadius:bdr-r/roundedRight,borderRightWidth:bd-r-w,borderSpacing:bd-sp,borderSpacingX:bd-sx,borderSpacingY:bd-sy,borderStartEndRadius:bdr-se/roundedStartEnd,borderStartRadius:bdr-s/roundedStart,borderStartStartRadius:bdr-ss/roundedStartStart,borderTop:bd-t,borderTopColor:bd-t-c,borderTopLeftRadius:bdr-tl/roundedTopLeft,borderTopRadius:bdr-t/roundedTop,borderTopRightRadius:bdr-tr/roundedTopRight,borderTopWidth:bd-t-w,borderWidth:bd-w,boxDecorationBreak:bx-db,boxShadow:bx-sh/shadow,boxShadowColor:bx-sh-c/shadowColor,boxSize:size,boxSizing:bx-s,caretColor:ca-c,clipPath:cp-path,color:c,columnGap:cg,container:cq,containerName:cq-n,containerType:cq-t,display:d,divideColor:dvd-c,divideStyle:dvd-s,divideX:dvd-x,divideY:dvd-y,flexBasis:flex-b,flexDirection:flex-d/flexDir,flexGrow:flex-g,flexShrink:flex-sh,focusRingColor:focus-ring-c,focusRingOffset:focus-ring-o,focusRingStyle:focus-ring-s,focusRingWidth:focus-ring-w,focusVisibleRing:focus-v-ring,fontFamily:ff,fontFeatureSettings:ff-s,fontKerning:fk,fontPalette:fp,fontSize:fs,fontSizeAdjust:fs-a,fontSmoothing:fsmt,fontVariant:fv,fontVariantAlternates:fv-alt,fontVariantCaps:fv-caps,fontVariantNumeric:fv-num,fontVariationSettings:fv-s,fontWeight:fw,gradientFrom:grad-from,gradientFromPosition:grad-from-pos,gradientTo:grad-to,gradientToPosition:grad-to-pos,gradientVia:grad-via,gradientViaPosition:grad-via-pos,gridAutoColumns:grid-ac,gridAutoFlow:grid-af,gridAutoRows:grid-ar,gridColumn:grid-c,gridColumnEnd:grid-ce,gridColumnGap:grid-cg,gridColumnStart:grid-cs,gridGap:grid-g,gridRow:grid-r,gridRowGap:grid-rg,gridTemplateColumns:grid-tc,gridTemplateRows:grid-tr,height:h/1,hideBelow:show,hideFrom:hide,hyphens:hy,inlineSize:w-is,insetBlock:inset-y/insetY,insetBlockEnd:inset-be,insetBlockStart:inset-bs,insetInline:inset-x/insetX,insetInlineEnd:inset-e/end/insetEnd,insetInlineStart:inset-s/insetStart/start,justifyContent:jc,letterSpacing:ls,lineClamp:lc,lineHeight:lh,listStyle:li-s,listStyleImage:li-img,listStylePosition:li-pos,listStyleType:li-t,margin:m/1,marginBlock:my/marginY/1,marginBlockEnd:mbe,marginBlockStart:mbs,marginBottom:mb/1,marginInline:mx/marginX/1,marginInlineEnd:me/marginEnd/1,marginInlineStart:ms/marginStart/1,marginLeft:ml/1,marginRight:mr/1,marginTop:mt/1,mask:msk,maskBottomFrom:msk-b-from,maskBottomFromColor:msk-b-from-c,maskBottomTo:msk-b-to,maskBottomToColor:msk-b-to-c,maskClip:msk-cp,maskComposite:msk-cmp,maskConic:msk-conic,maskConicFrom:msk-conic-from,maskConicFromColor:msk-conic-from-c,maskConicTo:msk-conic-to,maskConicToColor:msk-conic-to-c,maskImage:msk-i,maskLeftFrom:msk-l-from,maskLeftFromColor:msk-l-from-c,maskLeftTo:msk-l-to,maskLeftToColor:msk-l-to-c,maskLinear:msk-linear,maskLinearFrom:msk-linear-from,maskLinearFromColor:msk-linear-from-c,maskLinearTo:msk-linear-to,maskLinearToColor:msk-linear-to-c,maskMode:msk-md,maskOrigin:msk-o,maskPosition:msk-p,maskRadial:msk-radial,maskRadialAt:msk-radial-at,maskRadialFrom:msk-radial-from,maskRadialFromColor:msk-radial-from-c,maskRadialShape:msk-radial-shape,maskRadialSize:msk-radial-sz,maskRadialTo:msk-radial-to,maskRadialToColor:msk-radial-to-c,maskRepeat:msk-r,maskRightFrom:msk-r-from,maskRightFromColor:msk-r-from-c,maskRightTo:msk-r-to,maskRightToColor:msk-r-to-c,maskSize:msk-s,maskTopFrom:msk-t-from,maskTopFromColor:msk-t-from-c,maskTopTo:msk-t-to,maskTopToColor:msk-t-to-c,maskType:msk-t,maskXFrom:msk-x-from,maskXFromColor:msk-x-from-c,maskXTo:msk-x-to,maskXToColor:msk-x-to-c,maskYFrom:msk-y-from,maskYFromColor:msk-y-from-c,maskYTo:msk-y-to,maskYToColor:msk-y-to-c,maxBlockSize:max-b,maxHeight:max-h/maxH,maxInlineSize:max-w-is,maxWidth:max-w/maxW,minBlockSize:min-h-bs,minHeight:min-h/minH,minInlineSize:min-w-is,minWidth:min-w/minW,mixBlendMode:mix-bm,objectFit:obj-f,objectPosition:obj-p,opacity:op,outline:ring/1,outlineColor:ring-c/ringColor,outlineOffset:ring-o/ringOffset,outlineWidth:ring-w/ringWidth,overflow:ov,overflowAnchor:ov-a,overflowBlock:ov-b,overflowClipBox:ovcp-bx,overflowClipMargin:ovcp-m,overflowInline:ov-i,overflowWrap:ov-wrap,overflowX:ov-x,overflowY:ov-y,overscrollBehavior:ovs-b,overscrollBehaviorBlock:ovs-bb,overscrollBehaviorInline:ovs-bi,overscrollBehaviorX:ovs-bx,overscrollBehaviorY:ovs-by,padding:p/1,paddingBlock:py/paddingY/1,paddingBlockEnd:pbe,paddingBlockStart:pbs,paddingBottom:pb/1,paddingInline:px/paddingX/1,paddingInlineEnd:pe/paddingEnd/1,paddingInlineStart:ps/paddingStart/1,paddingLeft:pl/1,paddingRight:pr/1,paddingTop:pt/1,position:pos/1,rowGap:rg,scrollBehavior:scr-bhv,scrollMargin:scr-m,scrollMarginBlock:scr-my/scrollMarginY,scrollMarginBlockEnd:scr-mbe,scrollMarginBlockStart:scr-mbt,scrollMarginBottom:scr-mb,scrollMarginInline:scr-mx/scrollMarginX,scrollMarginInlineEnd:scr-me,scrollMarginInlineStart:scr-ms,scrollMarginLeft:scr-ml,scrollMarginRight:scr-mr,scrollMarginTop:scr-mt,scrollPadding:scr-p,scrollPaddingBlock:scr-py/scrollPaddingY,scrollPaddingBlockEnd:scr-pbe,scrollPaddingBlockStart:scr-pbs,scrollPaddingBottom:scr-pb,scrollPaddingInline:scr-px/scrollPaddingX,scrollPaddingInlineEnd:scr-pe,scrollPaddingInlineStart:scr-ps,scrollPaddingLeft:scr-pl,scrollPaddingRight:scr-pr,scrollPaddingTop:scr-pt,scrollSnapAlign:scr-sa,scrollSnapCoordinate:scrs-c,scrollSnapDestination:scrs-d,scrollSnapMargin:scrs-m,scrollSnapMarginBottom:scrs-mb,scrollSnapMarginLeft:scrs-ml,scrollSnapMarginRight:scrs-mr,scrollSnapMarginTop:scrs-mt,scrollSnapPointsX:scrs-px,scrollSnapPointsY:scrs-py,scrollSnapStop:scrs-s,scrollSnapStrictness:scrs-strt,scrollSnapType:scrs-t,scrollSnapTypeX:scrs-tx,scrollSnapTypeY:scrs-ty,scrollTimeline:scrtl,scrollTimelineAxis:scrtl-a,scrollTimelineName:scrtl-n,scrollbar:scr-bar,scrollbarColor:scr-bar-c,scrollbarGutter:scr-bar-g,scrollbarThumb:scr-bar-th,scrollbarTrack:scr-bar-tk,scrollbarWidth:scr-bar-w,spaceX:sx,spaceY:sy,srOnly:sr,stroke:stk,strokeDasharray:stk-dsh,strokeDashoffset:stk-do,strokeLinecap:stk-lc,strokeLinejoin:stk-lj,strokeMiterlimit:stk-ml,strokeOpacity:stk-op,strokeWidth:stk-w,tableLayout:tbl,textAlign:ta,textDecoration:td,textDecorationColor:td-c,textDecorationStyle:td-s,textDecorationThickness:td-t,textEmphasisColor:te-c,textGradient:txt-grad,textIndent:ti,textOverflow:tov,textShadow:tsh,textShadowColor:tsh-c/textShadowColor,textSizeAdjust:txt-adj,textStyle:textStyle,textTransform:tt,textUnderlineOffset:tu-o,textWrap:tw,touchAction:tch-a,transform:trf,transformBox:trf-b,transformOrigin:trf-o,transformStyle:trf-s,transition:trs,transitionDelay:trs-dly,transitionDuration:trs-dur,transitionProperty:trs-prop,transitionTimingFunction:trs-tmf,translateX:/x,translateY:/y,translateZ:/z,truncate:trunc,userSelect:us,verticalAlign:va,visibility:vis,width:w/1,wordBreak:wb,zIndex:z";
function createCssContext() {
	const classNameByProp = /* @__PURE__ */ new Map();
	const shorthands = /* @__PURE__ */ new Map();
	utilities.split(",").forEach((utility) => {
		const [prop, meta] = utility.split(":");
		const [className, ...shorthandList] = meta.split("/");
		if (className) classNameByProp.set(prop, className);
		shorthandList.forEach((shorthand) => {
			const key = shorthand === "1" ? className : shorthand;
			shorthands.set(key, prop);
		});
	});
	const resolveShorthand = (prop) => shorthands.get(prop) || prop;
	return {
		hash: true,
		conditions: {
			shift: sortConditions,
			finalize: finalizeConditions,
			breakpoints: { keys: breakpointKeys }
		},
		utility: {
			prefix: null,
			hasShorthand: true,
			toHash(path, hashFn) {
				return hashFn(path.join(":"));
			},
			transform(prop, value) {
				const key = resolveShorthand(prop);
				return { className: `${classNameByProp.get(key) || hypenateProperty(key)}_${withoutSpace(value)}` };
			},
			resolveShorthand
		}
	};
}
var cssContext = /* @__PURE__ */ createCssContext();
var serializeCss = /* @__PURE__ */ createSerializeCss(cssContext);
var mergeCss = /* @__PURE__ */ createMergeCss(cssContext);
var serializeCssArgs = /* @__PURE__ */ createSerializeCssArgs(serializeCss, mergeCss);
var css = /* @__PURE__ */ Object.assign(function css(...styles) {
	if (styles.length === 1 && isObject(styles[0])) return serializeCss(styles[0]);
	return serializeCssArgs(...styles);
}, { raw: function cssRaw(...styles) {
	return mergeCss(...styles);
} });
//#endregion
//#region ../../styled-system/styled-system/css/cva.js
var cva = (config) => {
	const defaults = (c) => ({
		base: {},
		variants: {},
		defaultVariants: {},
		compoundVariants: [],
		...c
	});
	const { base, variants, defaultVariants, compoundVariants } = defaults(config);
	const getVariantProps = (props) => withDefaults(defaultVariants, props);
	const resolve = (props = {}) => {
		const computed = getVariantProps(props);
		const styles = [base];
		for (const key in computed) {
			const value = computed[key];
			if (variants[key]?.[value]) styles.push(variants[key][value]);
		}
		styles.push(getCompoundVariantCss(compoundVariants, computed));
		return mergeCss(...styles);
	};
	const variantKeys = Object.keys(variants);
	const variantMap = toVariantMap(variants);
	const resolveMemo = memo(resolve);
	const merge = (other) => {
		const override = defaults(other.config);
		const keys = uniq(other.variantKeys, variantKeys);
		return cva({
			base: mergeCss(base, override.base),
			variants: Object.fromEntries(keys.map((key) => [key, mergeCss(variants[key], override.variants[key])])),
			defaultVariants: mergeProps(defaultVariants, override.defaultVariants),
			compoundVariants: [...compoundVariants, ...override.compoundVariants]
		});
	};
	return Object.assign(memo(function cvaFn(props) {
		return css(resolve(props));
	}), {
		__cva__: true,
		variantMap,
		variantKeys,
		raw: resolve,
		__memoizedRaw__: resolveMemo,
		config,
		merge,
		splitVariantProps(props) {
			return splitProps(props, variantKeys);
		},
		getVariantProps
	});
};
//#endregion
//#region src/table-cell.tsx
function TableCell({ sticky, css: cssFromProp, style, children, onHover, onLeave }) {
	const top = useMenuHeight();
	const _style = useMemo(() => ({
		...style,
		top: sticky ? top : void 0
	}), [
		style,
		top,
		sticky
	]);
	return /* @__PURE__ */ jsx("div", {
		style: _style,
		className: css({
			overflow: "hidden",
			paddingY: 4,
			paddingX: 6
		}, cssFromProp),
		onMouseOver: onHover,
		onMouseLeave: onLeave,
		children
	});
}
//#endregion
//#region src/table-context.ts
var context = createContext({
	setHoverCell: () => {},
	clearHoverCell: () => {},
	hoverCell: void 0,
	align: {},
	hoverColorChange: false
});
var { Provider: TableCodeBlockProvider } = context;
function useCurrentHoverCellXY() {
	const { hoverCell } = useContext(context);
	return [hoverCell?.x, hoverCell?.y];
}
function useSetHoverCell() {
	const { setHoverCell, clearHoverCell, hoverColorChange } = useContext(context);
	return hoverColorChange ? {
		setHoverCell,
		clearHoverCell
	} : {};
}
function useTableColor() {
	const { color = "primary" } = useContext(context);
	return color;
}
function useTableSticky() {
	const { stickyHead = false } = useContext(context);
	return stickyHead;
}
function useTableGalleryId() {
	const { galleryId } = useContext(context);
	return galleryId;
}
function useColumnAlign(columnIndex) {
	const { align } = useContext(context);
	return align[columnIndex] ?? "left";
}
function useHoverType(rowIndex, columnIndex) {
	const [hoverCellX, hoverCellY] = useCurrentHoverCellXY();
	return useMemo(() => {
		if (rowIndex < 0) return void 0;
		if (columnIndex === hoverCellX) {
			if (rowIndex === hoverCellY) return "cell";
			return "column";
		}
	}, [
		hoverCellX,
		hoverCellY,
		columnIndex,
		rowIndex
	]);
}
//#endregion
//#region src/constants.ts
var tableBorder = "1px solid var(--grey-100)";
//#endregion
//#region src/table-head.tsx
function TableHead({ head = [] }) {
	const sticky = useTableSticky();
	const color = useTableColor();
	const style = useCallback((index) => {
		const _style = { borderTop: tableBorder };
		if (index === 0) return {
			..._style,
			borderTopLeftRadius: 8,
			borderLeft: tableBorder
		};
		if (index === head.length - 1) return {
			..._style,
			borderTopRightRadius: 8,
			borderRight: tableBorder
		};
		return _style;
	}, [head.length]);
	if (!head.length) return null;
	return /* @__PURE__ */ jsx(Fragment, { children: head.map(({ label, align }, columnIndex) => /* @__PURE__ */ jsx(TableCell, {
		sticky,
		css: cva({
			base: {
				w: "full",
				h: "full",
				fontSize: "md",
				fontWeight: "bold",
				textTransform: "uppercase",
				borderBottomWidth: 2,
				borderBottomStyle: "solid"
			},
			variants: {
				color: {
					primary: {
						color: "accent.300",
						backgroundColor: "accent.50",
						borderBottomColor: "accent.200"
					},
					secondary: {
						color: "secondary.300",
						backgroundColor: "secondary.50",
						borderBottomColor: "secondary.200"
					},
					white: {
						color: "text.300",
						backgroundColor: "grey.50",
						borderBottomColor: "grey.200"
					}
				},
				align: {
					left: { textAlign: "left" },
					center: { textAlign: "center" },
					right: { textAlign: "right" }
				}
			}
		}).raw({
			color,
			align
		}),
		style: style(columnIndex),
		children: label
	}, label)) });
}
//#endregion
//#region src/table-body-header-cell-content.tsx
function TableBodyHeaderCellContent({ label, description, badge, icon, youtubeId, columnIndex }) {
	const { t } = useTranslation("core");
	const color = useTableColor();
	const galleryId = useTableGalleryId();
	const align = useColumnAlign(columnIndex);
	const iconColor = useMemo(() => {
		switch (color) {
			case "primary": return "var(--accent-500)";
			case "secondary": return "var(--secondary-500)";
			case "white": return "var(--text-500)";
		}
	}, [color]);
	return /* @__PURE__ */ jsxs("div", {
		className: cva({
			base: {
				w: "full",
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				gap: 4
			},
			variants: { align: {
				left: { justifyContent: "start" },
				center: { justifyContent: "center" },
				right: { justifyContent: "end" }
			} }
		})({ align }),
		children: [icon ? /* @__PURE__ */ jsx(FontAwesome, {
			name: icon,
			size: description ? 2 : 1,
			color: iconColor
		}) : null, /* @__PURE__ */ jsxs("div", {
			className: cva({
				base: {
					display: "flex",
					flexDirection: "column"
				},
				variants: { align: {
					left: { alignItems: "start" },
					center: { alignItems: "center" },
					right: { alignItems: "end" }
				} }
			})({ align }),
			children: [
				/* @__PURE__ */ jsxs("div", {
					className: css({
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						gap: 2
					}),
					children: [/* @__PURE__ */ jsx("span", {
						className: cva({
							base: {},
							variants: { align: {
								left: { textAlign: "left" },
								center: { textAlign: "center" },
								right: { textAlign: "right" }
							} }
						})({ align }),
						children: label
					}), badge ? /* @__PURE__ */ jsx(Badge, {
						color,
						css: css.raw({ display: "inline-block" }),
						children: badge
					}) : null]
				}),
				description ? /* @__PURE__ */ jsx("span", {
					className: cva({
						base: {
							fontSize: "sm",
							fontWeight: "normal",
							color: "grey.500",
							_firstLetter: { textTransform: "uppercase" }
						},
						variants: { align: {
							left: { textAlign: "left" },
							center: { textAlign: "center" },
							right: { textAlign: "right" }
						} }
					})({ align }),
					children: description
				}) : null,
				youtubeId && galleryId ? /* @__PURE__ */ jsx(LightGalleryItem, {
					id: galleryId,
					src: `https://www.youtube.com/watch?v=${youtubeId}`,
					children: /* @__PURE__ */ jsx("span", {
						className: cva({
							base: {
								fontSize: "sm",
								textDecoration: "underline"
							},
							variants: { align: {
								left: { textAlign: "left" },
								center: { textAlign: "center" },
								right: { textAlign: "right" }
							} }
						})({ align }),
						children: t("video.watch_video")
					})
				}) : null
			]
		})]
	});
}
//#endregion
//#region ../../styled-system/styled-system/tokens/index.js
var tokens = {
	"animations.bounce": "bounce 1s infinite",
	"animations.ping": "ping 1s cubic-bezier(0, 0, 0.2, 1) infinite",
	"animations.pulse": "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite",
	"animations.spin": "spin 1s linear infinite",
	"aspectRatios.golden": "1.618 / 1",
	"aspectRatios.landscape": "4 / 3",
	"aspectRatios.portrait": "3 / 4",
	"aspectRatios.square": "1 / 1",
	"aspectRatios.ultrawide": "18 / 5",
	"aspectRatios.video": "16 / 9",
	"aspectRatios.wide": "16 / 9",
	"blurs.2xl": "40px",
	"blurs.3xl": "64px",
	"blurs.lg": "16px",
	"blurs.md": "12px",
	"blurs.sm": "8px",
	"blurs.xl": "24px",
	"blurs.xs": "4px",
	"borders.none": "none",
	"breakpoints.2xl": "96rem",
	"breakpoints.desktop": "1024px",
	"breakpoints.lg": "64rem",
	"breakpoints.md": "48rem",
	"breakpoints.sm": "40rem",
	"breakpoints.tablet": "768px",
	"breakpoints.xl": "80rem",
	"breakpoints.xs": "300px",
	"colors.accent.100": "var(--accent-100)",
	"colors.accent.200": "var(--accent-200)",
	"colors.accent.300": "var(--accent-300)",
	"colors.accent.400": "var(--accent-400)",
	"colors.accent.50": "var(--accent-50)",
	"colors.accent.500": "var(--accent-500)",
	"colors.accent.600": "var(--accent-600)",
	"colors.accent.700": "var(--accent-700)",
	"colors.accent.800": "var(--accent-800)",
	"colors.accent.900": "var(--accent-900)",
	"colors.accent.950": "var(--accent-950)",
	"colors.amber.100": "oklch(96.2% 0.059 95.617)",
	"colors.amber.200": "oklch(92.4% 0.12 95.746)",
	"colors.amber.300": "oklch(87.9% 0.169 91.605)",
	"colors.amber.400": "oklch(82.8% 0.189 84.429)",
	"colors.amber.50": "oklch(98.7% 0.022 95.277)",
	"colors.amber.500": "oklch(76.9% 0.188 70.08)",
	"colors.amber.600": "oklch(66.6% 0.179 58.318)",
	"colors.amber.700": "oklch(55.5% 0.163 48.998)",
	"colors.amber.800": "oklch(47.3% 0.137 46.201)",
	"colors.amber.900": "oklch(41.4% 0.112 45.904)",
	"colors.amber.950": "oklch(27.9% 0.077 45.635)",
	"colors.background": "var(--background)",
	"colors.black": "#000",
	"colors.blue.100": "oklch(93.2% 0.032 255.585)",
	"colors.blue.200": "oklch(88.2% 0.059 254.128)",
	"colors.blue.300": "oklch(80.9% 0.105 251.813)",
	"colors.blue.400": "oklch(70.7% 0.165 254.624)",
	"colors.blue.50": "oklch(97% 0.014 254.604)",
	"colors.blue.500": "oklch(62.3% 0.214 259.815)",
	"colors.blue.600": "oklch(54.6% 0.245 262.881)",
	"colors.blue.700": "oklch(48.8% 0.243 264.376)",
	"colors.blue.800": "oklch(42.4% 0.199 265.638)",
	"colors.blue.900": "oklch(37.9% 0.146 265.522)",
	"colors.blue.950": "oklch(28.2% 0.091 267.935)",
	"colors.colorPalette": "",
	"colors.colorPalette.100": "",
	"colors.colorPalette.200": "",
	"colors.colorPalette.300": "",
	"colors.colorPalette.400": "",
	"colors.colorPalette.50": "",
	"colors.colorPalette.500": "",
	"colors.colorPalette.600": "",
	"colors.colorPalette.700": "",
	"colors.colorPalette.800": "",
	"colors.colorPalette.900": "",
	"colors.colorPalette.950": "",
	"colors.current": "currentcolor",
	"colors.cyan.100": "oklch(95.6% 0.045 203.388)",
	"colors.cyan.200": "oklch(91.7% 0.08 205.041)",
	"colors.cyan.300": "oklch(86.5% 0.127 207.078)",
	"colors.cyan.400": "oklch(78.9% 0.154 211.53)",
	"colors.cyan.50": "oklch(98.4% 0.019 200.873)",
	"colors.cyan.500": "oklch(71.5% 0.143 215.221)",
	"colors.cyan.600": "oklch(60.9% 0.126 221.723)",
	"colors.cyan.700": "oklch(52% 0.105 223.128)",
	"colors.cyan.800": "oklch(45% 0.085 224.283)",
	"colors.cyan.900": "oklch(39.8% 0.07 227.392)",
	"colors.cyan.950": "oklch(30.2% 0.056 229.695)",
	"colors.emerald.100": "oklch(95% 0.052 163.051)",
	"colors.emerald.200": "oklch(90.5% 0.093 164.15)",
	"colors.emerald.300": "oklch(84.5% 0.143 164.978)",
	"colors.emerald.400": "oklch(76.5% 0.177 163.223)",
	"colors.emerald.50": "oklch(97.9% 0.021 166.113)",
	"colors.emerald.500": "oklch(69.6% 0.17 162.48)",
	"colors.emerald.600": "oklch(59.6% 0.145 163.225)",
	"colors.emerald.700": "oklch(50.8% 0.118 165.612)",
	"colors.emerald.800": "oklch(43.2% 0.095 166.913)",
	"colors.emerald.900": "oklch(37.8% 0.077 168.94)",
	"colors.emerald.950": "oklch(26.2% 0.051 172.552)",
	"colors.error.300": "var(--error-300)",
	"colors.error.500": "var(--error-500)",
	"colors.error.700": "var(--error-700)",
	"colors.fuchsia.100": "oklch(95.2% 0.037 318.852)",
	"colors.fuchsia.200": "oklch(90.3% 0.076 319.62)",
	"colors.fuchsia.300": "oklch(83.3% 0.145 321.434)",
	"colors.fuchsia.400": "oklch(74% 0.238 322.16)",
	"colors.fuchsia.50": "oklch(97.7% 0.017 320.058)",
	"colors.fuchsia.500": "oklch(66.7% 0.295 322.15)",
	"colors.fuchsia.600": "oklch(59.1% 0.293 322.896)",
	"colors.fuchsia.700": "oklch(51.8% 0.253 323.949)",
	"colors.fuchsia.800": "oklch(45.2% 0.211 324.591)",
	"colors.fuchsia.900": "oklch(40.1% 0.17 325.612)",
	"colors.fuchsia.950": "oklch(29.3% 0.136 325.661)",
	"colors.gray.100": "var(--grey-100)",
	"colors.gray.200": "var(--grey-200)",
	"colors.gray.300": "var(--grey-300)",
	"colors.gray.400": "var(--grey-400)",
	"colors.gray.50": "var(--grey-50)",
	"colors.gray.500": "var(--grey-500)",
	"colors.gray.600": "var(--grey-600)",
	"colors.gray.700": "var(--grey-700)",
	"colors.gray.800": "var(--grey-800)",
	"colors.gray.900": "var(--grey-900)",
	"colors.gray.950": "var(--grey-950)",
	"colors.green.100": "oklch(96.2% 0.044 156.743)",
	"colors.green.200": "oklch(92.5% 0.084 155.995)",
	"colors.green.300": "oklch(87.1% 0.15 154.449)",
	"colors.green.400": "oklch(79.2% 0.209 151.711)",
	"colors.green.50": "oklch(98.2% 0.018 155.826)",
	"colors.green.500": "oklch(72.3% 0.219 149.579)",
	"colors.green.600": "oklch(62.7% 0.194 149.214)",
	"colors.green.700": "oklch(52.7% 0.154 150.069)",
	"colors.green.800": "oklch(44.8% 0.119 151.328)",
	"colors.green.900": "oklch(39.3% 0.095 152.535)",
	"colors.green.950": "oklch(26.6% 0.065 152.934)",
	"colors.grey.100": "var(--grey-100)",
	"colors.grey.200": "var(--grey-200)",
	"colors.grey.300": "var(--grey-300)",
	"colors.grey.400": "var(--grey-400)",
	"colors.grey.50": "var(--grey-50)",
	"colors.grey.500": "var(--grey-500)",
	"colors.grey.600": "var(--grey-600)",
	"colors.grey.700": "var(--grey-700)",
	"colors.grey.800": "var(--grey-800)",
	"colors.grey.900": "var(--grey-900)",
	"colors.grey.950": "var(--grey-950)",
	"colors.indigo.100": "oklch(93% 0.034 272.788)",
	"colors.indigo.200": "oklch(87% 0.065 274.039)",
	"colors.indigo.300": "oklch(78.5% 0.115 274.713)",
	"colors.indigo.400": "oklch(67.3% 0.182 276.935)",
	"colors.indigo.50": "oklch(96.2% 0.018 272.314)",
	"colors.indigo.500": "oklch(58.5% 0.233 277.117)",
	"colors.indigo.600": "oklch(51.1% 0.262 276.966)",
	"colors.indigo.700": "oklch(45.7% 0.24 277.023)",
	"colors.indigo.800": "oklch(39.8% 0.195 277.366)",
	"colors.indigo.900": "oklch(35.9% 0.144 278.697)",
	"colors.indigo.950": "oklch(25.7% 0.09 281.288)",
	"colors.info.300": "var(--info-300)",
	"colors.info.500": "var(--info-500)",
	"colors.info.700": "var(--info-700)",
	"colors.lime.100": "oklch(96.7% 0.067 122.328)",
	"colors.lime.200": "oklch(93.8% 0.127 124.321)",
	"colors.lime.300": "oklch(89.7% 0.196 126.665)",
	"colors.lime.400": "oklch(84.1% 0.238 128.85)",
	"colors.lime.50": "oklch(98.6% 0.031 120.757)",
	"colors.lime.500": "oklch(76.8% 0.233 130.85)",
	"colors.lime.600": "oklch(64.8% 0.2 131.684)",
	"colors.lime.700": "oklch(53.2% 0.157 131.589)",
	"colors.lime.800": "oklch(45.3% 0.124 130.933)",
	"colors.lime.900": "oklch(40.5% 0.101 131.063)",
	"colors.lime.950": "oklch(27.4% 0.072 132.109)",
	"colors.mauve.100": "oklch(96% 0.003 325.6)",
	"colors.mauve.200": "oklch(92.2% 0.005 325.62)",
	"colors.mauve.300": "oklch(86.5% 0.012 325.68)",
	"colors.mauve.400": "oklch(71.1% 0.019 323.02)",
	"colors.mauve.50": "oklch(98.5% 0 0)",
	"colors.mauve.500": "oklch(54.2% 0.034 322.5)",
	"colors.mauve.600": "oklch(43.5% 0.029 321.78)",
	"colors.mauve.700": "oklch(36.4% 0.029 323.89)",
	"colors.mauve.800": "oklch(26.3% 0.024 320.12)",
	"colors.mauve.900": "oklch(21.2% 0.019 322.12)",
	"colors.mauve.950": "oklch(14.5% 0.008 326)",
	"colors.mist.100": "oklch(96.3% 0.002 197.1)",
	"colors.mist.200": "oklch(92.5% 0.005 214.3)",
	"colors.mist.300": "oklch(87.2% 0.007 219.6)",
	"colors.mist.400": "oklch(72.3% 0.014 214.4)",
	"colors.mist.50": "oklch(98.7% 0.002 197.1)",
	"colors.mist.500": "oklch(56% 0.021 213.5)",
	"colors.mist.600": "oklch(45% 0.017 213.2)",
	"colors.mist.700": "oklch(37.8% 0.015 216)",
	"colors.mist.800": "oklch(27.5% 0.011 216.9)",
	"colors.mist.900": "oklch(21.8% 0.008 223.9)",
	"colors.mist.950": "oklch(14.8% 0.004 228.8)",
	"colors.neutral.100": "oklch(97% 0 0)",
	"colors.neutral.200": "oklch(92.2% 0 0)",
	"colors.neutral.300": "oklch(87% 0 0)",
	"colors.neutral.400": "oklch(70.8% 0 0)",
	"colors.neutral.50": "oklch(98.5% 0 0)",
	"colors.neutral.500": "oklch(55.6% 0 0)",
	"colors.neutral.600": "oklch(43.9% 0 0)",
	"colors.neutral.700": "oklch(37.1% 0 0)",
	"colors.neutral.800": "oklch(26.9% 0 0)",
	"colors.neutral.900": "oklch(20.5% 0 0)",
	"colors.neutral.950": "oklch(14.5% 0 0)",
	"colors.olive.100": "oklch(96.6% 0.005 106.5)",
	"colors.olive.200": "oklch(93% 0.007 106.5)",
	"colors.olive.300": "oklch(88% 0.011 106.6)",
	"colors.olive.400": "oklch(73.7% 0.021 106.9)",
	"colors.olive.50": "oklch(98.8% 0.003 106.5)",
	"colors.olive.500": "oklch(58% 0.031 107.3)",
	"colors.olive.600": "oklch(46.6% 0.025 107.3)",
	"colors.olive.700": "oklch(39.4% 0.023 107.4)",
	"colors.olive.800": "oklch(28.6% 0.016 107.4)",
	"colors.olive.900": "oklch(22.8% 0.013 107.4)",
	"colors.olive.950": "oklch(15.3% 0.006 107.1)",
	"colors.orange.100": "oklch(95.4% 0.038 75.164)",
	"colors.orange.200": "oklch(90.1% 0.076 70.697)",
	"colors.orange.300": "oklch(83.7% 0.128 66.29)",
	"colors.orange.400": "oklch(75% 0.183 55.934)",
	"colors.orange.50": "oklch(98% 0.016 73.684)",
	"colors.orange.500": "oklch(70.5% 0.213 47.604)",
	"colors.orange.600": "oklch(64.6% 0.222 41.116)",
	"colors.orange.700": "oklch(55.3% 0.195 38.402)",
	"colors.orange.800": "oklch(47% 0.157 37.304)",
	"colors.orange.900": "oklch(40.8% 0.123 38.172)",
	"colors.orange.950": "oklch(26.6% 0.079 36.259)",
	"colors.overAccent.100": "var(--over-accent-100)",
	"colors.overAccent.200": "var(--over-accent-200)",
	"colors.overAccent.300": "var(--over-accent-300)",
	"colors.overAccent.400": "var(--over-accent-400)",
	"colors.overAccent.50": "var(--over-accent-50)",
	"colors.overAccent.500": "var(--over-accent-500)",
	"colors.overAccent.600": "var(--over-accent-600)",
	"colors.overAccent.700": "var(--over-accent-700)",
	"colors.overAccent.800": "var(--over-accent-800)",
	"colors.overAccent.900": "var(--over-accent-900)",
	"colors.overAccent.950": "var(--over-accent-950)",
	"colors.overSecondary.100": "var(--over-secondary-100)",
	"colors.overSecondary.200": "var(--over-secondary-200)",
	"colors.overSecondary.300": "var(--over-secondary-300)",
	"colors.overSecondary.400": "var(--over-secondary-400)",
	"colors.overSecondary.50": "var(--over-secondary-50)",
	"colors.overSecondary.500": "var(--over-secondary-500)",
	"colors.overSecondary.600": "var(--over-secondary-600)",
	"colors.overSecondary.700": "var(--over-secondary-700)",
	"colors.overSecondary.800": "var(--over-secondary-800)",
	"colors.overSecondary.900": "var(--over-secondary-900)",
	"colors.overSecondary.950": "var(--over-secondary-950)",
	"colors.pink.100": "oklch(94.8% 0.028 342.258)",
	"colors.pink.200": "oklch(89.9% 0.061 343.231)",
	"colors.pink.300": "oklch(82.3% 0.12 346.018)",
	"colors.pink.400": "oklch(71.8% 0.202 349.761)",
	"colors.pink.50": "oklch(97.1% 0.014 343.198)",
	"colors.pink.500": "oklch(65.6% 0.241 354.308)",
	"colors.pink.600": "oklch(59.2% 0.249 0.584)",
	"colors.pink.700": "oklch(52.5% 0.223 3.958)",
	"colors.pink.800": "oklch(45.9% 0.187 3.815)",
	"colors.pink.900": "oklch(40.8% 0.153 2.432)",
	"colors.pink.950": "oklch(28.4% 0.109 3.907)",
	"colors.purple.100": "oklch(94.6% 0.033 307.174)",
	"colors.purple.200": "oklch(90.2% 0.063 306.703)",
	"colors.purple.300": "oklch(82.7% 0.119 306.383)",
	"colors.purple.400": "oklch(71.4% 0.203 305.504)",
	"colors.purple.50": "oklch(97.7% 0.014 308.299)",
	"colors.purple.500": "oklch(62.7% 0.265 303.9)",
	"colors.purple.600": "oklch(55.8% 0.288 302.321)",
	"colors.purple.700": "oklch(49.6% 0.265 301.924)",
	"colors.purple.800": "oklch(43.8% 0.218 303.724)",
	"colors.purple.900": "oklch(38.1% 0.176 304.987)",
	"colors.purple.950": "oklch(29.1% 0.149 302.717)",
	"colors.red.100": "oklch(93.6% 0.032 17.717)",
	"colors.red.200": "oklch(88.5% 0.062 18.334)",
	"colors.red.300": "oklch(80.8% 0.114 19.571)",
	"colors.red.400": "oklch(70.4% 0.191 22.216)",
	"colors.red.50": "oklch(97.1% 0.013 17.38)",
	"colors.red.500": "oklch(63.7% 0.237 25.331)",
	"colors.red.600": "oklch(57.7% 0.245 27.325)",
	"colors.red.700": "oklch(50.5% 0.213 27.518)",
	"colors.red.800": "oklch(44.4% 0.177 26.899)",
	"colors.red.900": "oklch(39.6% 0.141 25.723)",
	"colors.red.950": "oklch(25.8% 0.092 26.042)",
	"colors.rose.100": "oklch(94.1% 0.03 12.58)",
	"colors.rose.200": "oklch(89.2% 0.058 10.001)",
	"colors.rose.300": "oklch(81% 0.117 11.638)",
	"colors.rose.400": "oklch(71.2% 0.194 13.428)",
	"colors.rose.50": "oklch(96.9% 0.015 12.422)",
	"colors.rose.500": "oklch(64.5% 0.246 16.439)",
	"colors.rose.600": "oklch(58.6% 0.253 17.585)",
	"colors.rose.700": "oklch(51.4% 0.222 16.935)",
	"colors.rose.800": "oklch(45.5% 0.188 13.697)",
	"colors.rose.900": "oklch(41% 0.159 10.272)",
	"colors.rose.950": "oklch(27.1% 0.105 12.094)",
	"colors.secondary.100": "var(--secondary-100)",
	"colors.secondary.200": "var(--secondary-200)",
	"colors.secondary.300": "var(--secondary-300)",
	"colors.secondary.400": "var(--secondary-400)",
	"colors.secondary.50": "var(--secondary-50)",
	"colors.secondary.500": "var(--secondary-500)",
	"colors.secondary.600": "var(--secondary-600)",
	"colors.secondary.700": "var(--secondary-700)",
	"colors.secondary.800": "var(--secondary-800)",
	"colors.secondary.900": "var(--secondary-900)",
	"colors.secondary.950": "var(--secondary-950)",
	"colors.sky.100": "oklch(95.1% 0.026 236.824)",
	"colors.sky.200": "oklch(90.1% 0.058 230.902)",
	"colors.sky.300": "oklch(82.8% 0.111 230.318)",
	"colors.sky.400": "oklch(74.6% 0.16 232.661)",
	"colors.sky.50": "oklch(97.7% 0.013 236.62)",
	"colors.sky.500": "oklch(68.5% 0.169 237.323)",
	"colors.sky.600": "oklch(58.8% 0.158 241.966)",
	"colors.sky.700": "oklch(50% 0.134 242.749)",
	"colors.sky.800": "oklch(44.3% 0.11 240.79)",
	"colors.sky.900": "oklch(39.1% 0.09 240.876)",
	"colors.sky.950": "oklch(29.3% 0.066 243.157)",
	"colors.slate.100": "oklch(96.8% 0.007 247.896)",
	"colors.slate.200": "oklch(92.9% 0.013 255.508)",
	"colors.slate.300": "oklch(86.9% 0.022 252.894)",
	"colors.slate.400": "oklch(70.4% 0.04 256.788)",
	"colors.slate.50": "oklch(98.4% 0.003 247.858)",
	"colors.slate.500": "oklch(55.4% 0.046 257.417)",
	"colors.slate.600": "oklch(44.6% 0.043 257.281)",
	"colors.slate.700": "oklch(37.2% 0.044 257.287)",
	"colors.slate.800": "oklch(27.9% 0.041 260.031)",
	"colors.slate.900": "oklch(20.8% 0.042 265.755)",
	"colors.slate.950": "oklch(12.9% 0.042 264.695)",
	"colors.stone.100": "oklch(97% 0.001 106.424)",
	"colors.stone.200": "oklch(92.3% 0.003 48.717)",
	"colors.stone.300": "oklch(86.9% 0.005 56.366)",
	"colors.stone.400": "oklch(70.9% 0.01 56.259)",
	"colors.stone.50": "oklch(98.5% 0.001 106.423)",
	"colors.stone.500": "oklch(55.3% 0.013 58.071)",
	"colors.stone.600": "oklch(44.4% 0.011 73.639)",
	"colors.stone.700": "oklch(37.4% 0.01 67.558)",
	"colors.stone.800": "oklch(26.8% 0.007 34.298)",
	"colors.stone.900": "oklch(21.6% 0.006 56.043)",
	"colors.stone.950": "oklch(14.7% 0.004 49.25)",
	"colors.taupe.100": "oklch(96% 0.002 17.2)",
	"colors.taupe.200": "oklch(92.2% 0.005 34.3)",
	"colors.taupe.300": "oklch(86.8% 0.007 39.5)",
	"colors.taupe.400": "oklch(71.4% 0.014 41.2)",
	"colors.taupe.50": "oklch(98.6% 0.002 67.8)",
	"colors.taupe.500": "oklch(54.7% 0.021 43.1)",
	"colors.taupe.600": "oklch(43.8% 0.017 39.3)",
	"colors.taupe.700": "oklch(36.7% 0.016 35.7)",
	"colors.taupe.800": "oklch(26.8% 0.011 36.5)",
	"colors.taupe.900": "oklch(21.4% 0.009 43.1)",
	"colors.taupe.950": "oklch(14.7% 0.004 49.3)",
	"colors.teal.100": "oklch(95.3% 0.051 180.801)",
	"colors.teal.200": "oklch(91% 0.096 180.426)",
	"colors.teal.300": "oklch(85.5% 0.138 181.071)",
	"colors.teal.400": "oklch(77.7% 0.152 181.912)",
	"colors.teal.50": "oklch(98.4% 0.014 180.72)",
	"colors.teal.500": "oklch(70.4% 0.14 182.503)",
	"colors.teal.600": "oklch(60% 0.118 184.704)",
	"colors.teal.700": "oklch(51.1% 0.096 186.391)",
	"colors.teal.800": "oklch(43.7% 0.078 188.216)",
	"colors.teal.900": "oklch(38.6% 0.063 188.416)",
	"colors.teal.950": "oklch(27.7% 0.046 192.524)",
	"colors.text.200": "var(--text-200)",
	"colors.text.300": "var(--text-300)",
	"colors.text.500": "var(--text-500)",
	"colors.text.700": "var(--text-700)",
	"colors.transparent": "oklch(0 0 0 / 0)",
	"colors.valid.300": "var(--valid-300)",
	"colors.valid.500": "var(--valid-500)",
	"colors.valid.700": "var(--valid-700)",
	"colors.violet.100": "oklch(94.3% 0.029 294.588)",
	"colors.violet.200": "oklch(89.4% 0.057 293.283)",
	"colors.violet.300": "oklch(81.1% 0.111 293.571)",
	"colors.violet.400": "oklch(70.2% 0.183 293.541)",
	"colors.violet.50": "oklch(96.9% 0.016 293.756)",
	"colors.violet.500": "oklch(60.6% 0.25 292.717)",
	"colors.violet.600": "oklch(54.1% 0.281 293.009)",
	"colors.violet.700": "oklch(49.1% 0.27 292.581)",
	"colors.violet.800": "oklch(43.2% 0.232 292.759)",
	"colors.violet.900": "oklch(38% 0.189 293.745)",
	"colors.violet.950": "oklch(28.3% 0.141 291.089)",
	"colors.warning.300": "var(--warning-300)",
	"colors.warning.500": "var(--warning-500)",
	"colors.warning.700": "var(--warning-700)",
	"colors.white": "#fff",
	"colors.yellow.100": "oklch(97.3% 0.071 103.193)",
	"colors.yellow.200": "oklch(94.5% 0.129 101.54)",
	"colors.yellow.300": "oklch(90.5% 0.182 98.111)",
	"colors.yellow.400": "oklch(85.2% 0.199 91.936)",
	"colors.yellow.50": "oklch(98.7% 0.026 102.212)",
	"colors.yellow.500": "oklch(79.5% 0.184 86.047)",
	"colors.yellow.600": "oklch(68.1% 0.162 75.834)",
	"colors.yellow.700": "oklch(55.4% 0.135 66.442)",
	"colors.yellow.800": "oklch(47.6% 0.114 61.907)",
	"colors.yellow.900": "oklch(42.1% 0.095 57.708)",
	"colors.yellow.950": "oklch(28.6% 0.066 53.813)",
	"colors.zinc.100": "oklch(96.7% 0.001 286.375)",
	"colors.zinc.200": "oklch(92% 0.004 286.32)",
	"colors.zinc.300": "oklch(87.1% 0.006 286.286)",
	"colors.zinc.400": "oklch(70.5% 0.015 286.067)",
	"colors.zinc.50": "oklch(98.5% 0 0)",
	"colors.zinc.500": "oklch(55.2% 0.016 285.938)",
	"colors.zinc.600": "oklch(44.2% 0.017 285.786)",
	"colors.zinc.700": "oklch(37% 0.013 285.805)",
	"colors.zinc.800": "oklch(27.4% 0.006 286.033)",
	"colors.zinc.900": "oklch(21% 0.006 285.885)",
	"colors.zinc.950": "oklch(14.1% 0.005 285.823)",
	"durations.fast": "150ms",
	"durations.faster": "100ms",
	"durations.fastest": "50ms",
	"durations.normal": "200ms",
	"durations.slow": "300ms",
	"durations.slower": "400ms",
	"durations.slowest": "500ms",
	"easings.default": "cubic-bezier(0.4, 0, 0.2, 1)",
	"easings.in": "cubic-bezier(0.4, 0, 1, 1)",
	"easings.in-out": "cubic-bezier(0.4, 0, 0.2, 1)",
	"easings.linear": "linear",
	"easings.out": "cubic-bezier(0, 0, 0.2, 1)",
	"fontSizes.2xl": "1.5rem",
	"fontSizes.2xs": "0.5rem",
	"fontSizes.3xl": "1.875rem",
	"fontSizes.4xl": "2.25rem",
	"fontSizes.5xl": "3rem",
	"fontSizes.6xl": "3.75rem",
	"fontSizes.7xl": "4.5rem",
	"fontSizes.8xl": "6rem",
	"fontSizes.9xl": "8rem",
	"fontSizes.lg": "1.125rem",
	"fontSizes.md": "1rem",
	"fontSizes.sm": "0.875rem",
	"fontSizes.xl": "1.25rem",
	"fontSizes.xs": "0.75rem",
	"fontWeights.black": "900",
	"fontWeights.bold": "700",
	"fontWeights.extrabold": "800",
	"fontWeights.extralight": "200",
	"fontWeights.light": "300",
	"fontWeights.medium": "500",
	"fontWeights.normal": "400",
	"fontWeights.semibold": "600",
	"fontWeights.thin": "100",
	"fonts.mono": "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace",
	"fonts.sans": "ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"",
	"fonts.serif": "ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
	"letterSpacings.normal": "0em",
	"letterSpacings.tight": "-0.025em",
	"letterSpacings.tighter": "-0.05em",
	"letterSpacings.wide": "0.025em",
	"letterSpacings.wider": "0.05em",
	"letterSpacings.widest": "0.1em",
	"lineHeights.loose": "2",
	"lineHeights.none": "1",
	"lineHeights.normal": "1.5",
	"lineHeights.relaxed": "1.625",
	"lineHeights.snug": "1.375",
	"lineHeights.tight": "1.25",
	"radii.2xl": "1rem",
	"radii.3xl": "1.5rem",
	"radii.4xl": "2rem",
	"radii.full": "9999px",
	"radii.lg": "0.5rem",
	"radii.md": "0.375rem",
	"radii.sm": "0.25rem",
	"radii.xl": "0.75rem",
	"radii.xs": "0.125rem",
	"shadows.2xl": "0 25px 50px -12px rgb(0 0 0 / 0.25)",
	"shadows.2xs": "0 1px rgb(0 0 0 / 0.05)",
	"shadows.inner": "inset 0 2px 4px 0 rgb(0 0 0 / 0.05)",
	"shadows.inset-2xs": "inset 0 1px rgb(0 0 0 / 0.05)",
	"shadows.inset-sm": "inset 0 2px 4px rgb(0 0 0 / 0.05)",
	"shadows.inset-xs": "inset 0 1px 1px rgb(0 0 0 / 0.05)",
	"shadows.lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
	"shadows.md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
	"shadows.sm": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
	"shadows.xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
	"shadows.xs": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
	"sizes.0": "0rem",
	"sizes.0.5": "0.125rem",
	"sizes.1": "0.25rem",
	"sizes.1.5": "0.375rem",
	"sizes.10": "2.5rem",
	"sizes.11": "2.75rem",
	"sizes.12": "3rem",
	"sizes.14": "3.5rem",
	"sizes.16": "4rem",
	"sizes.2": "0.5rem",
	"sizes.2.5": "0.625rem",
	"sizes.20": "5rem",
	"sizes.24": "6rem",
	"sizes.28": "7rem",
	"sizes.2xl": "42rem",
	"sizes.3": "0.75rem",
	"sizes.3.5": "0.875rem",
	"sizes.32": "8rem",
	"sizes.36": "9rem",
	"sizes.3xl": "48rem",
	"sizes.4": "1rem",
	"sizes.4.5": "1.125rem",
	"sizes.40": "10rem",
	"sizes.44": "11rem",
	"sizes.48": "12rem",
	"sizes.4xl": "56rem",
	"sizes.5": "1.25rem",
	"sizes.5.5": "1.375rem",
	"sizes.52": "13rem",
	"sizes.56": "14rem",
	"sizes.5xl": "64rem",
	"sizes.6": "1.5rem",
	"sizes.60": "15rem",
	"sizes.64": "16rem",
	"sizes.6xl": "72rem",
	"sizes.7": "1.75rem",
	"sizes.72": "18rem",
	"sizes.7xl": "80rem",
	"sizes.8": "2rem",
	"sizes.80": "20rem",
	"sizes.8xl": "90rem",
	"sizes.9": "2.25rem",
	"sizes.96": "24rem",
	"sizes.breakpoint-2xl": "96rem",
	"sizes.breakpoint-desktop": "1024px",
	"sizes.breakpoint-lg": "64rem",
	"sizes.breakpoint-md": "48rem",
	"sizes.breakpoint-sm": "40rem",
	"sizes.breakpoint-tablet": "768px",
	"sizes.breakpoint-xl": "80rem",
	"sizes.breakpoint-xs": "300px",
	"sizes.container": "var(--container-size)",
	"sizes.fit": "fit-content",
	"sizes.full": "100%",
	"sizes.lg": "32rem",
	"sizes.max": "max-content",
	"sizes.md": "28rem",
	"sizes.min": "min-content",
	"sizes.narrowContainer": "var(--narrow-container-size)",
	"sizes.prose": "60ch",
	"sizes.sm": "24rem",
	"sizes.xl": "36rem",
	"sizes.xs": "20rem",
	"spacing.-0.5": "calc(var(--gEfgCY) * -1)",
	"spacing.-1": "calc(var(--dacYEG) * -1)",
	"spacing.-1.5": "calc(var(--jJIQbV) * -1)",
	"spacing.-10": "calc(var(--ieMJEa) * -1)",
	"spacing.-11": "calc(var(--cBFxYr) * -1)",
	"spacing.-12": "calc(var(--uyqLg) * -1)",
	"spacing.-14": "calc(var(--hXmVPi) * -1)",
	"spacing.-16": "calc(var(--mYCWo) * -1)",
	"spacing.-2": "calc(var(--ebuyxV) * -1)",
	"spacing.-2.5": "calc(var(--cqwGG) * -1)",
	"spacing.-20": "calc(var(--jgejxp) * -1)",
	"spacing.-24": "calc(var(--iYEvIx) * -1)",
	"spacing.-28": "calc(var(--dzpWeZ) * -1)",
	"spacing.-3": "calc(var(--bYDCFo) * -1)",
	"spacing.-3.5": "calc(var(--dhUgfD) * -1)",
	"spacing.-32": "calc(var(--fifqnK) * -1)",
	"spacing.-36": "calc(var(--faFCyS) * -1)",
	"spacing.-4": "calc(var(--hIimNX) * -1)",
	"spacing.-4.5": "calc(var(--jjtyTI) * -1)",
	"spacing.-40": "calc(var(--bxwoov) * -1)",
	"spacing.-44": "calc(var(--huPzrf) * -1)",
	"spacing.-48": "calc(var(--hgdKvb) * -1)",
	"spacing.-5": "calc(var(--fFrqVq) * -1)",
	"spacing.-5.5": "calc(var(--ZByTJ) * -1)",
	"spacing.-52": "calc(var(--cZMJbQ) * -1)",
	"spacing.-56": "calc(var(--iXfUeA) * -1)",
	"spacing.-6": "calc(var(--gGIQOF) * -1)",
	"spacing.-60": "calc(var(--vWSpd) * -1)",
	"spacing.-64": "calc(var(--gtqdrN) * -1)",
	"spacing.-7": "calc(var(--eDRUVY) * -1)",
	"spacing.-72": "calc(var(--hNtIEu) * -1)",
	"spacing.-8": "calc(var(--flZesP) * -1)",
	"spacing.-80": "calc(var(--kqIPsj) * -1)",
	"spacing.-9": "calc(var(--djiiAi) * -1)",
	"spacing.-96": "calc(var(--wdMRQ) * -1)",
	"spacing.0": "0rem",
	"spacing.0.5": "0.125rem",
	"spacing.1": "0.25rem",
	"spacing.1.5": "0.375rem",
	"spacing.10": "2.5rem",
	"spacing.11": "2.75rem",
	"spacing.12": "3rem",
	"spacing.14": "3.5rem",
	"spacing.16": "4rem",
	"spacing.2": "0.5rem",
	"spacing.2.5": "0.625rem",
	"spacing.20": "5rem",
	"spacing.24": "6rem",
	"spacing.28": "7rem",
	"spacing.3": "0.75rem",
	"spacing.3.5": "0.875rem",
	"spacing.32": "8rem",
	"spacing.36": "9rem",
	"spacing.4": "1rem",
	"spacing.4.5": "1.125rem",
	"spacing.40": "10rem",
	"spacing.44": "11rem",
	"spacing.48": "12rem",
	"spacing.5": "1.25rem",
	"spacing.5.5": "1.375rem",
	"spacing.52": "13rem",
	"spacing.56": "14rem",
	"spacing.6": "1.5rem",
	"spacing.60": "15rem",
	"spacing.64": "16rem",
	"spacing.7": "1.75rem",
	"spacing.72": "18rem",
	"spacing.8": "2rem",
	"spacing.80": "20rem",
	"spacing.9": "2.25rem",
	"spacing.96": "24rem"
};
var tokenVars = {
	"sizes.0.5": "var(--hghuKL)",
	"sizes.1.5": "var(--drtIxO)",
	"sizes.2.5": "var(--siblR)",
	"sizes.3.5": "var(--hSPYxQ)",
	"sizes.4.5": "var(--fHQhyH)",
	"sizes.5.5": "var(--bTcvlK)",
	"spacing.-0.5": "var(--gEfgCY)",
	"spacing.-1": "var(--dacYEG)",
	"spacing.-1.5": "var(--jJIQbV)",
	"spacing.-10": "var(--ieMJEa)",
	"spacing.-11": "var(--cBFxYr)",
	"spacing.-12": "var(--uyqLg)",
	"spacing.-14": "var(--hXmVPi)",
	"spacing.-16": "var(--mYCWo)",
	"spacing.-2": "var(--ebuyxV)",
	"spacing.-2.5": "var(--cqwGG)",
	"spacing.-20": "var(--jgejxp)",
	"spacing.-24": "var(--iYEvIx)",
	"spacing.-28": "var(--dzpWeZ)",
	"spacing.-3": "var(--bYDCFo)",
	"spacing.-3.5": "var(--dhUgfD)",
	"spacing.-32": "var(--fifqnK)",
	"spacing.-36": "var(--faFCyS)",
	"spacing.-4": "var(--hIimNX)",
	"spacing.-4.5": "var(--jjtyTI)",
	"spacing.-40": "var(--bxwoov)",
	"spacing.-44": "var(--huPzrf)",
	"spacing.-48": "var(--hgdKvb)",
	"spacing.-5": "var(--fFrqVq)",
	"spacing.-5.5": "var(--ZByTJ)",
	"spacing.-52": "var(--cZMJbQ)",
	"spacing.-56": "var(--iXfUeA)",
	"spacing.-6": "var(--gGIQOF)",
	"spacing.-60": "var(--vWSpd)",
	"spacing.-64": "var(--gtqdrN)",
	"spacing.-7": "var(--eDRUVY)",
	"spacing.-72": "var(--hNtIEu)",
	"spacing.-8": "var(--flZesP)",
	"spacing.-80": "var(--kqIPsj)",
	"spacing.-9": "var(--djiiAi)",
	"spacing.-96": "var(--wdMRQ)",
	"spacing.0.5": "var(--gEfgCY)",
	"spacing.1.5": "var(--jJIQbV)",
	"spacing.2.5": "var(--cqwGG)",
	"spacing.3.5": "var(--dhUgfD)",
	"spacing.4.5": "var(--jjtyTI)",
	"spacing.5.5": "var(--ZByTJ)"
};
var resolveVar = (path) => tokenVars[path] || toCssVar(path);
var token = /* @__PURE__ */ Object.assign(function token(path, fallback) {
	const value = tokens[path];
	return value === void 0 ? colorMix(tokens, path, resolveVar) || fallback : value || resolveVar(path);
}, { var: function tokenVar(path, fallback) {
	return tokens[path] === void 0 ? fallback : resolveVar(path);
} });
//#endregion
//#region src/table-body-data-cell-content.tsx
function TableBodyDataCellContent({ tick = false, tickLabel, columnIndex }) {
	const align = useColumnAlign(columnIndex);
	return /* @__PURE__ */ jsxs("div", {
		className: cva({
			base: {
				w: "full",
				display: "flex",
				flexDirection: "column",
				gap: 2
			},
			variants: { align: {
				left: { alignItems: "start" },
				center: { alignItems: "center" },
				right: { alignItems: "end" }
			} }
		})({ align }),
		children: [/* @__PURE__ */ jsx(FontAwesome, {
			name: `fa-solid fa-${tick ? "check" : "xmark"}`,
			color: token(tick ? "colors.valid.500" : "colors.text.300"),
			size: 2
		}), tickLabel ? /* @__PURE__ */ jsx("span", {
			className: css({
				fontSize: "xs",
				color: "grey.500"
			}),
			children: tickLabel
		}) : null]
	});
}
//#endregion
//#region src/table-body.tsx
function TableBodyCell({ position: { x: columnIndex, y: rowIndex }, css: cssFromProp, rowCount, columnCount, ...props }) {
	const { setHoverCell, clearHoverCell } = useSetHoverCell();
	const hover = useHoverType(rowIndex, columnIndex);
	const color = useTableColor();
	const onHover = useMemo(() => {
		if (!setHoverCell) return void 0;
		return () => {
			setHoverCell(columnIndex, rowIndex);
		};
	}, [
		setHoverCell,
		columnIndex,
		rowIndex
	]);
	const style = useMemo(() => ({
		borderLeft: columnIndex === 0 ? tableBorder : void 0,
		borderTop: rowIndex > 0 ? tableBorder : void 0,
		borderRight: columnIndex === columnCount - 1 ? tableBorder : void 0,
		borderBottom: rowIndex === rowCount - 1 ? tableBorder : void 0,
		borderBottomLeftRadius: rowIndex === rowCount - 1 && columnIndex === 0 ? 8 : void 0,
		borderBottomRightRadius: rowIndex === rowCount - 1 && columnIndex === columnCount - 1 ? 8 : void 0
	}), [
		columnIndex,
		rowIndex,
		rowCount,
		columnCount
	]);
	return /* @__PURE__ */ jsx(TableCell, {
		onHover,
		onLeave: clearHoverCell,
		style,
		css: cva({
			base: {
				w: "full",
				h: "full",
				display: "flex",
				alignItems: "center",
				...cssFromProp
			},
			variants: {
				hover: {
					cell: {},
					column: {},
					undefined: {}
				},
				color: {
					primary: {},
					secondary: {},
					white: {}
				},
				even: {
					true: {},
					false: {}
				}
			},
			compoundVariants: [
				{
					hover: "cell",
					color: "primary",
					css: { backgroundColor: "accent.100" }
				},
				{
					hover: "column",
					color: "primary",
					css: { backgroundColor: "accent.50" }
				},
				{
					hover: "cell",
					color: "secondary",
					css: { backgroundColor: "secondary.100" }
				},
				{
					hover: "column",
					color: "secondary",
					css: { backgroundColor: "secondary.50" }
				},
				{
					hover: "cell",
					color: "white",
					css: { backgroundColor: "grey.100" }
				},
				{
					hover: "column",
					color: "white",
					css: { backgroundColor: "grey.50" }
				},
				{
					hover: void 0,
					even: true,
					css: { backgroundColor: "white" }
				},
				{
					hover: void 0,
					color: "primary",
					even: false,
					css: { backgroundColor: "var(--accent-50)" }
				},
				{
					hover: void 0,
					color: "secondary",
					even: false,
					css: { backgroundColor: "var(--secondary-50)" }
				},
				{
					hover: void 0,
					color: "white",
					even: false,
					css: { backgroundColor: "var(--grey-50)" }
				}
			]
		}).raw({
			hover,
			color,
			even: rowIndex % 2 === 0
		}),
		...props
	});
}
function TableBody({ body = [[]] }) {
	const rowCount = useMemo(() => body.length, [body.length]);
	const columnCount = useMemo(() => body[0].length, [body]);
	if (!body.length) return null;
	return /* @__PURE__ */ jsx(Fragment, { children: body.map((row, rowIndex) => row.map(({ label, tick, tickLabel, badge, description, icon, youtubeId }, columnIndex) => /* @__PURE__ */ jsx(TableBodyCell, {
		position: {
			x: columnIndex,
			y: rowIndex
		},
		rowCount,
		columnCount,
		children: label ? /* @__PURE__ */ jsx(TableBodyHeaderCellContent, {
			label,
			description,
			icon,
			youtubeId,
			badge,
			columnIndex
		}) : /* @__PURE__ */ jsx(TableBodyDataCellContent, {
			tick,
			tickLabel,
			columnIndex
		})
	}, `${rowIndex.toString()}-${columnIndex.toString()}`))) });
}
//#endregion
//#region src/table.tsx
function Table({ uuid, code }) {
	const [hoverCell, _setHoverCell] = useState();
	const setHoverCell = useCallback((x, y) => {
		_setHoverCell({
			x,
			y
		});
	}, []);
	const clearHoverCell = useCallback(() => {
		_setHoverCell(void 0);
	}, []);
	const { color = "primary", stickyHead, head = [], body = [[]], minCellWidth, hoverColorChange = false } = code ?? {};
	const align = useMemo(() => head.reduce((obj, { align: _a = "left" }, columnIndex) => ({
		...obj,
		[columnIndex]: _a
	}), {}), [head]);
	const galleryId = useMemo(() => {
		return body.some((row) => row.some(({ youtubeId }) => Boolean(youtubeId))) ? `table-${uuid}-video` : void 0;
	}, [uuid, body]);
	const style = useMemo(() => {
		return {
			gridTemplateColumns: head.reduce((str, { width }) => {
				let value;
				if (width !== void 0) value = `${width.toString()}px`;
				else if (minCellWidth !== void 0) value = `minmax(${minCellWidth.toString()}px, 1fr)`;
				else value = "1fr";
				return `${str} ${value}`;
			}, ""),
			borderRadius: 8
		};
	}, [head, minCellWidth]);
	if (!head.length && !body.length) return null;
	const content = /* @__PURE__ */ jsxs("div", {
		className: css({
			w: "full",
			display: "grid",
			overflowX: "auto"
		}),
		style,
		children: [/* @__PURE__ */ jsx(TableHead, { head }), /* @__PURE__ */ jsx(TableBody, { body })]
	});
	return /* @__PURE__ */ jsx(TableCodeBlockProvider, {
		value: {
			setHoverCell,
			clearHoverCell,
			hoverCell,
			color,
			stickyHead,
			galleryId,
			align,
			hoverColorChange
		},
		children: galleryId ? /* @__PURE__ */ jsx(LightGallery, {
			id: galleryId,
			elementClassNames: css({ w: "full" }),
			children: content
		}) : content
	});
}
//#endregion
//#region src/code-block.tsx
var code_block_exports = /* @__PURE__ */ __exportAll({ CodeBlock: () => CodeBlock });
function CodeBlock({ uuid, code }) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [code?.type === "html" && /* @__PURE__ */ jsx(RawHtml, {
		code,
		uuid
	}), code?.type === "table" && /* @__PURE__ */ jsx(Table, {
		code,
		uuid
	})] });
}
//#endregion
export { code_block_exports as n, CodeBlock as t };
